/* ============================================================
   sc-data.js
   Source of truth for all product, fabric, review and copy data
   used by the prototype. Lifted from the brief's appendix
   (sources of truth) and from the Nadia system prompt v1.6.
   Change here, changes on every page.
   ============================================================ */

window.SC = window.SC || {};

/* The sofa ranges:
   - Six Sophie Conran ranges sold direct: Coco, Barton, Henrietta, Isobel, Felix, Sophia
   - Cocobella: sister to Coco, John Lewis exclusive (UK)
   - Salthrop: designed by Alex Willcock, John Lewis exclusive (UK), not a Sophie Conran sofa
*/
/* Sophie Conran range structure: 6 SC sofas sold direct (Coco, Barton, Henrietta, Isobel, Felix, Sophia) */
SC.ranges = [
  {
    handle: 'coco',
    name: 'Coco',
    proposition: 'The deepest, most loved.',
    spring: 'Individual coil sprung',
    notes: 'Sizes 1 to 4, plus Sofa Bed, Modular, Footstool. Fully bespoke. Split-frame option on standard sofa, not on sofa bed.',
    fromPrice: 5895,
    leadTimeWeeks: 8,
    image: 'coco-lifestyle'
  },
  {
    handle: 'barton',
    name: 'Barton',
    proposition: 'Generous, statement, deep.',
    spring: 'Individual coil sprung',
    notes: 'Deepest sofa at 120cm. Sizes 1.5, 2, 3. COM available.',
    fromPrice: 6720,
    leadTimeWeeks: 8,
    image: 'barton-lifestyle'
  },
  {
    handle: 'isobel',
    name: 'Isobel',
    proposition: 'Slimmer, elegant curve.',
    spring: 'Fishmouth steel + zig-zag back',
    notes: 'Sizes 1 to 4. COM available.',
    fromPrice: 4150,
    leadTimeWeeks: 8,
    image: 'isobel-lifestyle'
  },
  {
    handle: 'henrietta',
    name: 'Henrietta',
    proposition: 'Tailored, structured back.',
    spring: 'Individual coil sprung',
    notes: 'Sizes 1 and 2.5 only. Mahogany leg only.',
    fromPrice: 4920,
    leadTimeWeeks: 8,
    image: 'henrietta-lifestyle'
  },
  {
    handle: 'felix',
    name: 'Felix',
    proposition: 'Fixed back, family-ready.',
    spring: 'Fishmouth steel + zig-zag back',
    notes: 'Fixed back, not removable. Sizes 1 to 4.',
    fromPrice: 3895,
    leadTimeWeeks: 7,
    image: 'felix-lifestyle'
  },
  {
    handle: 'salthrop',
    name: 'Salthrop',
    proposition: 'Designed by Alex for John Lewis. UK only.',
    spring: 'Fishmouth steel',
    notes: '119cm deep. Loose cover with dressmaker skirt. Curated fabric range. Designed by Alex Willcock, sold exclusively through John Lewis (UK).',
    fromPrice: 2950,
    leadTimeWeeks: 10,
    image: 'salthrop-lifestyle',
    soldThrough: 'John Lewis'
  },
  {
    handle: 'cocobella',
    name: 'Cocobella',
    proposition: 'Sister to the Coco. At John Lewis.',
    spring: 'Fishmouth steel',
    notes: 'Sister to Coco. Sold exclusively through John Lewis (UK). Recycled foam and feather. Knife edge only.',
    fromPrice: null,
    leadTimeWeeks: 10,
    image: 'cocobella-lifestyle',
    soldThrough: 'John Lewis'
  },
  {
    handle: 'sophia',
    name: 'Sophia',
    proposition: 'Fixed cover, mahogany leg.',
    spring: 'Foam core (fixed)',
    notes: 'Fixed cover, fixed back. Sizes 1, 2, 3. Mahogany leg only.',
    fromPrice: 3450,
    leadTimeWeeks: 7,
    image: 'sophia-lifestyle'
  }
];

/* The fabrics, with strict care rules from Nadia v1.6 */
/* ── Contrast piping pairings ──
   For launch, contrast piping is offered only on a curated set of body
   fabrics, each with a designated contrast fabric chosen by the design
   team. The configurator uses this map two ways:
     1. VISIBILITY: contrast piping options (any value starting
        'contrast-') only appear when the selected body fabric has an
        entry here. Fabrics without an entry show self/soft options only.
     2. PRICING: when contrast piping is selected, the paired handle is
        sent to the pricing calculator as `pipingFabric`.
   To offer contrast on another fabric, add one line:
     'body-fabric-handle': 'contrast-fabric-handle',
   Handles are the configurator's fabric handles (the fabricCategories
   vocabulary, same as share URLs). */
SC.contrastPairings = {
  'wildwood-ivory':                 'pelham-moss',
  'wildwood-duck-egg':              'pelham-clementine',
  'wildwood-twig':                  'pelham-peacock',
  'english-garden-kitty-blue-green':'omega-pine',
  'magnolia-cream-blue':            'omega-winter-moss'
};

SC.fabrics = {
  'cool-coconut': {
    name: 'Cool Coconut',
    composition: 'Plain cotton-linen',
    care: 'Machine-washable at 30°C',
    natural: true,
    family: true,
    swatchColour: '#E8DDC9',
    swatchAccent: '#D4C5A8'
  },
  'snow-drop': {
    name: 'Snow Drop',
    composition: 'Plain cotton-linen',
    care: 'Machine-washable at 30°C',
    natural: true,
    family: true,
    swatchColour: '#EFE9DA',
    swatchAccent: '#DDD4BD'
  },
  'wildwood-duck-egg': {
    name: 'Wildwood Duck Egg',
    composition: 'Viscose-linen blend, floral print',
    care: 'Dry-clean only',
    natural: false,
    family: false,
    swatchColour: '#A8C0BC',
    swatchAccent: '#7A9590',
    print: 'floral'
  },
  'english-garden': {
    name: 'English Garden',
    composition: 'Floral, mixed base',
    care: 'Dry-clean only',
    natural: false,
    family: false,
    swatchColour: '#D8C4A6',
    swatchAccent: '#A88B62',
    print: 'floral'
  },
  'dandelion-stripe': {
    name: 'Dandelion Stripe',
    composition: 'Organic yarn striped, cotton-linen base',
    care: 'Machine-washable at 30°C',
    natural: true,
    family: true,
    swatchColour: '#E8D89B',
    swatchAccent: '#B89A5E',
    print: 'stripe'
  },
  'petunia-stripe': {
    name: 'Stripe Petunia',
    composition: 'Organic yarn striped, cotton-linen base',
    care: 'Machine-washable at 30°C',
    natural: true,
    family: true,
    swatchColour: '#D89090',
    swatchAccent: '#B56A4F',
    print: 'stripe'
  },
  'coastal-blue-stripe': {
    name: 'Coastal Blue Stripe',
    composition: 'Organic yarn striped, cotton-linen base',
    care: 'Machine-washable at 30°C',
    natural: true,
    family: true,
    swatchColour: '#A8B5C9',
    swatchAccent: '#3F5777',
    print: 'stripe'
  },
  'cornish-blue-stripe': {
    name: 'Cornish Blue Stripe',
    composition: 'Organic yarn striped, cotton-linen base',
    care: 'Machine-washable at 30°C',
    natural: true,
    family: true,
    swatchColour: '#9DB0C4',
    swatchAccent: '#1B2D4A',
    print: 'stripe'
  },
  'olive-green-stripe': {
    name: 'Olive Green Stripe',
    composition: 'Organic yarn striped, cotton-linen base',
    care: 'Machine-washable at 30°C',
    natural: true,
    family: true,
    swatchColour: '#B5BBA0',
    swatchAccent: '#7A8B6F',
    print: 'stripe'
  },
  'beatrice-camelia': {
    name: 'Beatrice Camelia',
    composition: 'Plain, off-white',
    care: 'Defer to team',
    natural: null,
    family: null,
    swatchColour: '#EFE9DA',
    swatchAccent: '#C8BFAA'
  },
  'beatrice-olive': {
    name: 'Beatrice Olive',
    composition: 'Plain olive',
    care: 'Defer to team',
    natural: null,
    family: null,
    swatchColour: '#9CA587',
    swatchAccent: '#6F7A5B'
  },
  'beatrice-midnight': {
    name: 'Beatrice Midnight',
    composition: 'Plain navy',
    care: 'Defer to team',
    natural: null,
    family: null,
    swatchColour: '#3F5777',
    swatchAccent: '#1B2D4A'
  },
  'beatrice-barley': {
    name: 'Beatrice Barley',
    composition: 'Plain brown',
    care: 'Defer to team',
    natural: null,
    family: null,
    swatchColour: '#B59E7C',
    swatchAccent: '#8A7558'
  },
  'brera-lino-putty': {
    name: 'Designers Guild Brera Lino Putty',
    composition: 'Cocobella exclusive fabric',
    care: 'Defer to team',
    natural: null,
    family: null,
    note: 'Excluded from the discount programme.',
    swatchColour: '#CDC0A8',
    swatchAccent: '#A89A82'
  },
  'varese-saffron': {
    name: 'Designers Guild Varese Saffron',
    composition: 'Cocobella exclusive velvet',
    care: 'Dry-clean only',
    natural: false,
    family: false,
    note: 'Excluded from the discount programme.',
    swatchColour: '#D9A85C',
    swatchAccent: '#B58238'
  },
  'arona-denim': {
    name: 'Designers Guild Arona (Boho Denim)',
    composition: 'Cocobella exclusive plain',
    care: 'Defer to team',
    natural: null,
    family: null,
    note: 'Excluded from the discount programme.',
    swatchColour: '#7A8FA8',
    swatchAccent: '#506B85'
  },
  'herring-gull-stripe': {
    name: 'Herring Gull Stripe',
    composition: 'Organic yarn striped',
    care: 'Machine-washable at 30°C',
    natural: true,
    family: true,
    swatchColour: '#C8C8C0',
    swatchAccent: '#7A7A6F',
    print: 'stripe'
  },
  'magnolia': {
    name: 'Magnolia',
    composition: 'Plain cotton-linen',
    care: 'Machine-washable at 30°C',
    natural: true,
    family: true,
    swatchColour: '#F0E5D0',
    swatchAccent: '#D8C5A0'
  },
  'wildwood-ivory': {
    name: 'Wild Wood Ivory',
    composition: 'Floral on cotton-linen base',
    care: 'Dry-clean only',
    natural: false,
    family: false,
    swatchColour: '#E8DBC0',
    swatchAccent: '#A89070',
    print: 'floral'
  },
  'pelham-moss-velvet': {
    name: 'Pelham Moss Velvet',
    composition: 'Cotton-mix velvet',
    care: 'Dry-clean only',
    natural: false,
    family: false,
    swatchColour: '#5C6E54',
    swatchAccent: '#3B4A36',
    print: 'velvet'
  }
};

/* Fabric categories: for the product configurator sub-selector.
   Each list is the set of fabric handles available within that category. */
SC.fabricCategories = {
  'plain':   [
    'snow-drop', 'cool-coconut', 'sea-salt', 'rosedale', 'inkspot',
    'evergreen', 'marigold', 'potting-moss', 'roselette', 'sunflower',
    'beatrice-barley', 'beatrice-camelia', 'beatrice-midnight', 'beatrice-nutmeg', 'beatrice-olive',
    'froisse-cerulean', 'froisse-chalk', 'froisse-hemp', 'froisse-khaki', 'froisse-mole',
    'froisse-pebble', 'froisse-putty', 'froisse-sisal',
    'elba-cerulean', 'elba-hemp', 'elba-midnight', 'elba-sage',
    'brera-lino-cerise', 'brera-lino-chalk', 'brera-lino-putty',
    'boho-cloud', 'boho-denim', 'boho-parchment',
    'picocesto-selenite', 'picocesto-sunstone',
    'omega-folly', 'omega-grass'
  ],
  'striped': [
    'coastal-blue', 'petunia', 'woodland-stripe', 'caramel-stripe',
    'sea-holly', 'garden-grey', 'dandelion', 'spring-green', 'cornish-blue',
    'narrow-chocolate', 'chocolate', 'blossom', 'las-salinas-4'
  ],
  'floral':  [
    'wildwood-duck-egg', 'wildwood-ivory', 'wildwood-twig',
    'peony-summer-sky', 'midsummer-sky', 'midsummer-stone', 'midsummer-faded-blue',
    'otter-denim', 'berrington',
    'nympheus-teal-green', 'nympheus-stone-pistachio', 'nympheus-aqua-teal',
    'magnolia-cream-blue', 'little-magnolia-pink-orange', 'little-magnolia-espresso', 'little-magnolia-emerald',
    'english-garden-kitty-spring-green', 'english-garden-kitty-blue-green', 'english-garden-kitty-indian-summer',
    'english-garden-albertine-grey-skies', 'english-garden-albertine-classic-rose', 'english-garden-albertine-coral-orange',
    'belleville-miji-juniper'
  ],
  'velvet':  [
    'pelham-clementine', 'pelham-moss', 'pelham-denim', 'pelham-peacock',
    'varese-fuchsia', 'varese-alchemilla', 'varese-grass',
    'omega-lagoon', 'omega-pastel-blue', 'omega-rosewood',
    'omega-winter-moss', 'omega-pine', 'omega-pillarbox',
    'omega-carnelian', 'omega-parakeet'
  ]
};

/* Real fabric sample images from the Shopify Fabric Samples collection.
   Used by the product page fabric sub-selector to render swatches as actual
   close-up photos of the cloth rather than CSS gradients. */
SC.fabricImages = {
  'cool-coconut':         'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/cool_coconut.webp?v=1719661219&width=200',
  'snow-drop':            'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/snow_drop.webp?v=1719657854&width=200',
  'sea-salt':             'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/sea_salt.webp?v=1719658555&width=200',
  'wildwood-duck-egg':    'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/wwduckeggdb.webp?v=1719655771&width=200',
  'wildwood-ivory':      'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/wwivorydb.webp?v=1719657072&width=200',
  'midsummer-faded-blue': 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/midsummer_faded_blue_5.webp?v=1719644636&width=200',
  'brera-lino-chalk':     'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/varese_steel_f1190_93.webp?v=1719662422&width=200',
  'varese-saffron':       'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/varese_steel_f1190_93.webp?v=1719662422&width=200'
};

/* Sea Salt is the new lead plain. Add it as an SC.fabrics entry too. */
SC.fabrics['sea-salt'] = {
  name: 'Sea Salt',
  composition: 'Plain cotton-linen',
  care: 'Machine-washable at 30°C',
  natural: true,
  family: true,
  swatchColour: '#E0DAC8',
  swatchAccent: '#C5BBA1'
};
SC.fabrics['stripes-sea-holly'] = {
  name: 'Sea Holly Stripe',
  composition: 'Blue and white woven stripe, 100% cotton',
  care: 'Machine-washable at 30°C',
  natural: true,
  family: true,
  swatchColour: '#A8BFC8',
  swatchAccent: '#FFFFFF',
  print: 'stripe'
};
SC.fabrics['garden-grey-stripe'] = {
  name: 'Garden Grey Stripe',
  composition: 'Woven stripe',
  care: 'Machine-washable at 30°C',
  natural: true,
  family: true,
  swatchColour: '#B6B8AE',
  swatchAccent: '#FFFFFF',
  print: 'stripe'
};
SC.fabrics['midsummer-faded-blue'] = {
  name: 'Midsummer Faded Blue',
  composition: 'Floral cotton print',
  care: 'Dry-clean only',
  natural: false,
  family: false,
  swatchColour: '#9CA9B5',
  swatchAccent: '#6A8090',
  print: 'floral'
};
SC.fabrics['brera-lino-chalk'] = {
  name: 'Brera Lino Chalk',
  composition: 'Linen, Designers Guild',
  care: 'Dry-clean only',
  natural: true,
  family: true,
  swatchColour: '#E8E2D5',
  swatchAccent: '#CFC8B8'
};

/* Premium fabrics: trigger the premiumFabricSurcharge in configurationRules. */
['wildwood-duck-egg', 'wildwood-ivory', 'brera-lino-chalk', 'varese-saffron', 'pelham-moss-velvet', 'beatrice-midnight'].forEach(function(handle) {
  if (SC.fabrics[handle]) SC.fabrics[handle].priceTier = 'premium';
});

/* ============================================================
   CONFIGURATION RULES — per range
   ============================================================
   Each range declares its option groups, the valid values within
   each group, dependency rules between groups, base prices, and
   defaults. The configurator UI is a model render of this object.

   For the demo this is local data. In production the same shape
   is returned by the Vercel pricing calculator, prefetched once
   per page load, then queried client-side for instant updates.

   Rule shape:
     - groups[].options[] are the available values
     - groups[].options[].requires / .excludes encodes inter-group
       constraints (e.g. piping option only valid for certain cushion)
     - groups[].options[].bespoke = true marks bespoke-only options
       that surface but prompt the customer to email sofas@sophieconran.com
     - basePriceBySize provides placeholder demo pricing per size
     - When wired to the live Vercel calculator, basePriceBySize and
       any priceDelta on options are replaced by a single live lookup.
*/

/* ── John Lewis fabric list ──
   The 24 fabrics John Lewis stocks across Cocobella, Salthrop and Felix
   (JLP), grouped by the Pattern column of the JLP master sheet. The main
   picker draws from SC.fabricCategories, which is the full Sophie Conran
   library and includes fabrics John Lewis does not sell, so these ranges
   use this list instead. */
/* ── John Lewis fabrics, per range ──
   Derived from the render manifest, not assumed. The three ranges do NOT
   share one list: Felix (JLP) has all 24, Cocobella 13 and Salthrop 12.
   Offering a fabric with no render behind it is what produced the blank
   swatches and "Image coming soon", so each range lists only what has
   actually been rendered. */
SC.jlpFabricsByRange = {
  /* Cocobella, Oct 2026: discontinued fabrics removed (SC Deletions sheet)
     and Beauville dropped. Bruges, Suzy, Pinstripe and Tasman Natural have
     no price yet, so they show "Price on request" until configurator.jl_prices
     on the product carries them. */
  'cocobella': {
      'plain': ['beatrice-barley', 'beatrice-camelia', 'beatrice-midnight', 'beatrice-nutmeg', 'beatrice-olive', 'boho-cloud', 'boho-denim', 'boho-parchment', 'bruges-navy', 'bruges-sand', 'bruges-sage'],
      'striped': ['coastal-blue-stripe', 'cornish-blue-stripe', 'petunia-stripe', 'spring-green-stripe', 'natural-stripe', 'pinstripe-natural', 'pinstripe-petunia', 'pinstripe-nutmeg'],
      'floral': ['suzy-olive', 'suzy-denim', 'suzy-natural']
    },
  /* Salthrop and Felix II, Oct 2026: discontinued fabrics removed (SC
     Deletions sheet) and new John Lewis fabrics added from their SKU list.
     Beauville (JL "Deauville") left out, as on Cocobella. Salthrop has no
     Bruges at John Lewis; Felix II has no new Boho Parchment SKU but the
     existing Medium and Large are not discontinued, so it stays. */
  'salthrop': {
      'plain': ['beatrice-barley', 'beatrice-camelia', 'beatrice-midnight', 'beatrice-nutmeg', 'beatrice-olive', 'boho-cloud', 'boho-denim', 'boho-parchment'],
      'striped': ['coastal-blue-stripe', 'cornish-blue-stripe', 'petunia-stripe', 'spring-green-stripe', 'natural-stripe', 'pinstripe-natural', 'pinstripe-petunia', 'pinstripe-nutmeg'],
      'floral': ['suzy-olive', 'suzy-denim', 'suzy-natural']
    },
  'felix-jl': {
      'plain': ['beatrice-barley', 'beatrice-camelia', 'beatrice-midnight', 'beatrice-nutmeg', 'beatrice-olive', 'boho-cloud', 'boho-denim', 'boho-parchment', 'bruges-navy', 'bruges-sand', 'bruges-sage'],
      'striped': ['coastal-blue-stripe', 'cornish-blue-stripe', 'petunia-stripe', 'spring-green-stripe', 'natural-stripe', 'pinstripe-natural', 'pinstripe-petunia', 'pinstripe-nutmeg'],
      'floral': ['suzy-olive', 'suzy-denim', 'suzy-natural']
    }
};

SC.jlpFabricCategories = {
  'plain': [
    'beatrice-barley', 'beatrice-camelia', 'beatrice-midnight',
    'beatrice-nutmeg', 'beatrice-olive',
    'boho-cloud', 'boho-denim', 'boho-parchment',
    'bruges-navy', 'bruges-sand', 'bruges-sage'
  ],
  'striped': [
    'coastal-blue-stripe', 'cornish-blue-stripe', 'petunia-stripe',
    'spring-green-stripe', 'natural-stripe',
    'pinstripe-natural', 'pinstripe-petunia', 'pinstripe-nutmeg',
    'beauville-spring-green', 'beauville-cornish-blue'
  ],
  'floral': [
    'suzy-olive', 'suzy-denim', 'suzy-natural'
  ]
};

SC.configurationRules = {
  /* ── John Lewis ranges ──────────────────────────────────────────────
     Cocobella, Salthrop and Felix (JLP) are made for John Lewis and are
     ordered through them, so these pages are showcases: the retailer URL
     on the template replaces Add to basket with a link out and hides the
     price (John Lewis sets it).

     Size and fabric are selectable on all three, and Salthrop also offers
     a back cushion choice because it is rendered both ways. Cover, piping
     and cushion fill do not vary on these ranges, so they render no
     buttons and are not listed here at all. The render lookup still needs codes
     for them, and gets them from MODEL_DEFAULTS in sc-image-resolver.js
     rather than from a selection.

     No basePriceBySize: the configurator guards against its absence and
     the price is suppressed for retailer ranges anyway. Adding fake
     numbers here would risk them surfacing if a retailer URL were ever
     left blank. */
  cocobella: {
    fabricSource: 'jlp',
    rangeName: 'Cocobella',
    retailerRange: true,
    /* Show the John Lewis price (from the product's configurator.jl_prices
       metafield) while keeping the link out instead of Add to basket.
       The Armchair is discontinued (Oct 2026) so is not offered. The
       'snuggler' value is kept because the render codes key off it, but
       John Lewis and our product titles call it a Loveseat. */
    retailerPrice: true,
    defaultSize: 'medium',
    groups: [
      {
        key: 'size',
        label: 'Size',
        options: [
          { value: 'snuggler', label: 'Loveseat' },
          { value: 'small',    label: 'Small' },
          { value: 'medium',   label: 'Medium' },
          { value: 'large',    label: 'Large' },
          { value: 'grand',    label: 'Grand' },
          { value: 'left-hand-2x3',  label: 'Left hand 2x3' },
          { value: 'right-hand-2x3', label: 'Right hand 2x3' },
          { value: 'corner-3x3',     label: '3x3 corner' }
        ]
      },
      {
        key: 'fabric',
        label: 'Fabric',
        help: 'Fabrics available on this range at John Lewis.',
        options: [
          { value: 'plain',   label: 'Plain' },
          { value: 'striped', label: 'Striped' },
          { value: 'floral',  label: 'Floral' }
        ]
      }
    ]
  },

  salthrop: {
    fabricSource: 'jlp',
    rangeName: 'Salthrop',
    retailerRange: true,
    /* John Lewis price shown, priced per back cushion style too: the
       product's configurator.jl_prices keys are 'size|cushion'. */
    retailerPrice: true,
    defaultSize: 'medium',
    groups: [
      {
        key: 'size',
        label: 'Size',
        options: [
          { value: 'snuggler', label: 'Loveseat' },
          { value: 'medium',   label: 'Medium' },
          { value: 'large',    label: 'Large' }
        ]
      },
      {
        key: 'fabric',
        label: 'Fabric',
        help: 'Fabrics available on this range at John Lewis.',
        options: [
          { value: 'plain',   label: 'Plain' },
          { value: 'striped', label: 'Striped' },
          { value: 'floral',  label: 'Floral' }
        ]
      },
      {
        /* Salthrop is the one John Lewis range rendered both ways. The key
           must stay 'cushion' because B and S sit in the cushion slot of the
           SKU (KSAS30B / KSAS30S), even though what changes is the back. Both
           styles are rendered for all 24 fabrics and all three sizes. */
        key: 'cushion',
        label: 'Back cushion',
        help: 'Big back has one large cushion per seat. Scatter back has a set of smaller loose cushions.',
        options: [
          { value: 'box-edge-big',     label: 'Big back' },
          { value: 'box-edge-scatter', label: 'Scatter back' }
        ]
      }
    ]
  },

  'felix-jl': {
    fabricSource: 'jlp',
    /* Renamed Felix II for John Lewis, Oct 2026. The range key stays
       'felix-jl' because the render filenames use 'Felix (JLP)'. */
    rangeName: 'Felix II',
    retailerRange: true,
    retailerPrice: true,
    defaultSize: 'medium',
    groups: [
      {
        key: 'size',
        label: 'Size',
        options: [
          { value: 'armchair', label: 'Armchair' },
          { value: 'medium',   label: 'Medium' },
          { value: 'large',    label: 'Large' }
        ]
      },
      {
        key: 'fabric',
        label: 'Fabric',
        help: 'Fabrics available on this range at John Lewis.',
        options: [
          { value: 'plain',   label: 'Plain' },
          { value: 'striped', label: 'Striped' },
          { value: 'floral',  label: 'Floral' }
        ]
      }
    ]
  },

  coco: {
    rangeName: 'Coco',
    defaultSize: '2.5-seater',
    /* Placeholder base prices per size, for the demo only.
       Real pricing comes from the Vercel calculator at integration time. */
    basePriceBySize: {
      'armchair':    3450,
      'loveseat':    4895,
      '2-seater':    5395,
      '2.5-seater':  5895,
      '3-seater':    6420,
      '3.5-seater':  6950,
      '4-seater':    7420
    },
    /* Flat premium for fabrics tagged premium in SC.fabrics */
    premiumFabricSurcharge: 200,
    /* Pricing tool: Back Cushion Style is Big Back only for Coco. */
    fixed: {
      backCushion: { label: 'Back cushion', value: 'big-back', display: 'Big back' }
    },
    groups: [
      {
        key: 'size',
        label: 'Size',
        help: 'Each size has its own dimensions. See the table further down.',
        options: [
          { value: 'armchair',   label: 'Armchair' },
          { value: 'loveseat',   label: 'Loveseat' },
          { value: '2-seater',   label: '2-seater' },
          { value: '2.5-seater', label: '2.5-seater' },
          { value: '3-seater',   label: '3-seater' },
          { value: '3.5-seater', label: '3.5-seater' },
          { value: '4-seater',   label: '4-seater' },
          { value: '4.5-seater', label: '4.5-seater', markets: ['UK'] }
        ]
      },
      {
        key: 'fabric',
        label: 'Fabric',
        help: 'Free samples within a week, up to five per request.',
        /* Fabric uses the existing category sub-selector pattern. Each category
           applies a percentage multiplier on the base size price. Premium handles
           (marked in SC.fabrics.priceTier === 'premium') add a further £200. */
        options: [
          { value: 'plain',   label: 'Plain linen',         priceMultiplier: 1.00 },
          { value: 'striped', label: 'Striped',             priceMultiplier: 1.05 },
          { value: 'floral',  label: 'Floral',              priceMultiplier: 1.12 },
          { value: 'velvet',  label: 'Velvet',              priceMultiplier: 1.15 },
          { value: 'bespoke', label: 'COM (your own fabric)', bespoke: true }
        ]
      },
      {
        key: 'cushion',
        label: 'Seat cushion',
        help: 'Knife edge is the classic Coco profile. Box edge sits firmer and squarer.',
        options: [
          { value: 'knife', label: 'Knife edge', priceDelta: 0 },
          { value: 'box',   label: 'Box edge',   priceDelta: 120 }
        ]
      },
      {
        key: 'cover',
        label: 'Cover style',
        help: 'Loose covers come off for cleaning. The standard skirt is dressmaker.',
        options: [
          { value: 'loose',    label: 'Loose, dressmaker skirt', priceDelta: 0 },
          { value: 'fixed',    label: 'Fixed cover',             priceDelta: -180 },
          { value: 'boxpleat', label: 'Loose, box pleat skirt' },
          { value: 'ruffle',   label: 'Loose, ruffle skirt',    bespoke: true }
        ]
      },
      {
        key: 'frame',
        label: 'Frame',
        help: 'Split-frame arrives in two halves and is assembled in your room. Built for tight access (narrow doorways, awkward stairs, period properties). Loose-cover builds only.',
        options: [
          { value: 'standard', label: 'Standard frame', priceDelta: 0 },
          { value: 'split',    label: 'Split-frame for access', priceDelta: 220, requires: { cover: ['loose', 'boxpleat', 'ruffle'] } }
        ]
      },
      {
        key: 'piping',
        label: 'Piping',
        help: 'The detail along the cushion edge. Some options pair with knife edge, some with box.',
        options: [
          { value: 'self-flat',     label: 'Self flat',     priceDelta:   0, requires: { cushion: ['knife', 'box'] } },
          { value: 'contrast-flat', label: 'Contrast flat', priceDelta:  90, requires: { cushion: ['knife', 'box'] }, requiresContrastPairing: true },
          { value: 'self-round',    label: 'Self round',    priceDelta: 140, requires: { cushion: ['box'] } },
          { value: 'contrast-round',label: 'Contrast round',priceDelta: 180, requires: { cushion: ['box'] }, requiresContrastPairing: true },
          { value: 'oxford',        label: 'Oxford border', priceDelta: 220, requires: { cushion: ['knife'] } },
          { value: 'soft-edge',     label: 'Soft edge',     priceDelta:  60, requires: { cushion: ['knife', 'box'] } }
        ]
      },
      {
        key: 'cushionFill',
        label: 'Cushion fill',
        help: 'The filling inside the seat cushions.',
        autoHideIfSingle: true,
        options: [
          { value: 'foam-core',            label: 'Foam core (standard)',  isDefault: true, markets: ['UK'] },
          { value: 'sustainable-foam-core', label: 'Sustainable foam core', markets: ['UK'] },
          { value: 'all-feather',          label: 'All feather',            markets: ['UK'] },
          { value: 'natural-latex-core',   label: 'Natural latex core',     markets: ['UK'] },
          { value: 'all-feather-down',     label: 'All feather & down',    markets: ['UK'] },
          { value: 'fiber-down-foam',      label: 'Fiber, down and foam',  isDefault: true, markets: ['US'] },
          { value: 'all-feather-down',     label: 'All feather & down',    markets: ['US'] },
          { value: 'natural-latex-core',   label: 'Natural latex core',     markets: ['US'] }
        ]
      },
      {
        key: 'legStyle',
        label: 'Leg style',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'walcot',     label: 'Walcot' },
          { value: 'draycot',    label: 'Draycot' },
          { value: 'liddington', label: 'Liddington' },
          { value: 'wroughton',  label: 'Wroughton' }
        ]
      },
      {
        key: 'legFinish',
        label: 'Leg finish',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'walnut',   label: 'Walnut',  requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'natural',  label: 'Natural', requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'ebony',    label: 'Ebony',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'antique-bronze', label: 'Antique bronze', requires: { legStyle: ['wroughton'] } },
          { value: 'chrome',         label: 'Chrome',         requires: { legStyle: ['wroughton'] } },
          { value: 'bronze',         label: 'Bronze',         requires: { legStyle: ['wroughton'] } },
          { value: 'wax-ash', label: 'Wax ash', isDefault: true, requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] },
          { value: 'sable',   label: 'Sable',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] },
          { value: 'walnut',  label: 'Walnut',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] }
        ]
      }
    ]
  },

  /* ----------------------------------------------------------
     Isobel
     Six sizes. Back cushion fixed at Big Back, seat at Box Edge.
     Cover: fixed or loose dressmaker. Three piping options.
     ---------------------------------------------------------- */
  isobel: {
    rangeName: 'Isobel',
    defaultSize: '2.5-seater',
    basePriceBySize: {
      'armchair':    2750,
      'loveseat':    3750,
      '2-seater':    3950,
      '2.5-seater':  4150,
      '3-seater':    4550,
      '4-seater':    5350
    },
    premiumFabricSurcharge: 200,
    /* Configuration values that aren't user-choosable. Surfaced in the
       build summary and persisted in the share URL so they round-trip. */
    fixed: {
      backCushion: { label: 'Back cushion', value: 'big-back', display: 'Big back' },
      cushion:     { label: 'Seat cushion', value: 'box',      display: 'Box edge' }
    },
    groups: [
      {
        key: 'size',
        label: 'Size',
        options: [
          { value: 'armchair',   label: 'Armchair' },
          { value: 'loveseat',   label: 'Loveseat' },
          { value: '2-seater',   label: '2-seater' },
          { value: '2.5-seater', label: '2.5-seater' },
          { value: '3-seater',   label: '3-seater' },
          { value: '4-seater',   label: '4-seater' }
        ]
      },
      {
        key: 'fabric',
        label: 'Fabric',
        help: 'Free samples within a week, up to five per request.',
        options: [
          { value: 'plain',   label: 'Plain linen',         priceMultiplier: 1.00 },
          { value: 'striped', label: 'Striped',             priceMultiplier: 1.05 },
          { value: 'floral',  label: 'Floral',              priceMultiplier: 1.12 },
          { value: 'velvet',  label: 'Velvet',              priceMultiplier: 1.15 },
          { value: 'bespoke', label: 'COM (your own fabric)', bespoke: true }
        ]
      },
      {
        key: 'cover',
        label: 'Cover style',
        help: 'Loose covers come off for cleaning. The standard skirt is dressmaker.',
        /* Pricing tool: UK Isobel is fixed-cover only; loose and box pleat are US options. */
        options: [
          { value: 'fixed',    label: 'Fixed cover',             priceDelta: -180, isDefault: true },
          { value: 'loose',    label: 'Loose, dressmaker skirt', priceDelta:   0,  markets: ['US'] },
          { value: 'boxpleat', label: 'Loose, box pleat skirt',  markets: ['US'] }
        ]
      },
      {
        key: 'frame',
        label: 'Frame',
        help: 'Split-frame arrives in two halves and is assembled in your room. Built for tight access.',
        /* Pricing tool prices splits for Isobel under fixed covers too, so no cover requirement here. */
        options: [
          { value: 'standard', label: 'Standard frame', priceDelta: 0 },
          { value: 'split',    label: 'Split-frame for access', priceDelta: 220 }
        ]
      },
      {
        key: 'piping',
        label: 'Piping',
        help: 'Soft edge is the softest. Self round is invisible. Contrast round adds a definition line.',
        options: [
          { value: 'self-round',     label: 'Self round',     priceDelta: 140 },
          { value: 'contrast-round', label: 'Contrast round', priceDelta: 180, requiresContrastPairing: true },
          { value: 'soft-edge',      label: 'Soft edge',      priceDelta:  60 }
        ]
      }
      ,
      {
        key: 'cushionFill',
        label: 'Cushion fill',
        help: 'The filling inside the seat cushions.',
        autoHideIfSingle: true,
        options: [
          { value: 'sustainable-foam-core', label: 'Sustainable foam core', isDefault: true, markets: ['UK'] },
          { value: 'fiber-down-foam', label: 'Fiber, down and foam', isDefault: true, markets: ['US'] }
        ]
      },
      {
        key: 'legStyle',
        label: 'Leg style',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'walcot',     label: 'Walcot' },
          { value: 'draycot',    label: 'Draycot' },
          { value: 'liddington', label: 'Liddington' }
        ]
      },
      {
        key: 'legFinish',
        label: 'Leg finish',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'walnut',  label: 'Walnut',  requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'natural', label: 'Natural', requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'ebony',   label: 'Ebony',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'wax-ash', label: 'Wax ash', requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] },
          { value: 'sable',   label: 'Sable',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] },
          { value: 'walnut',  label: 'Walnut',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] }
        ]
      }
    ]
  },

  /* ----------------------------------------------------------
     Felix
     Six sizes. Fixed back cushion, Box Edge seat.
     Cover: fixed or loose dressmaker. Three piping options.
     ---------------------------------------------------------- */
  felix: {
    rangeName: 'Felix',
    defaultSize: '2.5-seater',
    basePriceBySize: {
      'armchair':    2495,
      'loveseat':    3450,
      '2-seater':    3650,
      '2.5-seater':  3895,
      '3-seater':    4250,
      '4-seater':    5050
    },
    premiumFabricSurcharge: 200,
    fixed: {
      backCushion: { label: 'Back cushion', value: 'fixed', display: 'Fixed' },
      cushion:     { label: 'Seat cushion', value: 'box',   display: 'Box edge' }
    },
    groups: [
      {
        key: 'size',
        label: 'Size',
        options: [
          { value: 'armchair',   label: 'Armchair' },
          { value: 'loveseat',   label: 'Loveseat' },
          { value: '2-seater',   label: '2-seater' },
          { value: '2.5-seater', label: '2.5-seater' },
          { value: '3-seater',   label: '3-seater' },
          { value: '4-seater',   label: '4-seater' }
        ]
      },
      {
        key: 'fabric',
        label: 'Fabric',
        help: 'Free samples within a week, up to five per request.',
        options: [
          { value: 'plain',   label: 'Plain linen',         priceMultiplier: 1.00 },
          { value: 'striped', label: 'Striped',             priceMultiplier: 1.05 },
          { value: 'floral',  label: 'Floral',              priceMultiplier: 1.12 },
          { value: 'velvet',  label: 'Velvet',              priceMultiplier: 1.15 },
          { value: 'bespoke', label: 'COM (your own fabric)', bespoke: true }
        ]
      },
      {
        key: 'cover',
        label: 'Cover style',
        help: 'Loose covers come off for cleaning. The standard skirt is dressmaker.',
        /* Pricing tool: UK Felix is fixed-cover only; loose and box pleat are US options. */
        options: [
          { value: 'fixed',    label: 'Fixed cover',             priceDelta: -180, isDefault: true },
          { value: 'loose',    label: 'Loose, dressmaker skirt', priceDelta:   0,  markets: ['US'] },
          { value: 'boxpleat', label: 'Loose, box pleat skirt',  markets: ['US'] }
        ]
      },
      {
        key: 'frame',
        label: 'Frame',
        help: 'Split-frame arrives in two halves and is assembled in your room. Built for tight access.',
        /* Pricing tool prices splits for Felix under fixed covers too, so no cover requirement here. */
        options: [
          { value: 'standard', label: 'Standard frame', priceDelta: 0 },
          { value: 'split',    label: 'Split-frame for access', priceDelta: 220 }
        ]
      },
      {
        key: 'piping',
        label: 'Piping',
        options: [
          { value: 'self-round',     label: 'Self round',     priceDelta: 140 },
          { value: 'contrast-round', label: 'Contrast round', priceDelta: 180, requiresContrastPairing: true },
          { value: 'soft-edge',      label: 'Soft edge',      priceDelta:  60 }
        ]
      }
      ,
      {
        key: 'cushionFill',
        label: 'Cushion fill',
        help: 'The filling inside the seat cushions.',
        autoHideIfSingle: true,
        options: [
          { value: 'sustainable-foam-core', label: 'Sustainable foam core', isDefault: true, markets: ['UK'] },
          { value: 'fiber-down-foam', label: 'Fiber, down and foam', isDefault: true, markets: ['US'] }
        ]
      },
      {
        key: 'legStyle',
        label: 'Leg style',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'walcot',     label: 'Walcot' },
          { value: 'draycot',    label: 'Draycot' },
          { value: 'liddington', label: 'Liddington' }
        ]
      },
      {
        key: 'legFinish',
        label: 'Leg finish',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'walnut',  label: 'Walnut',  requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'natural', label: 'Natural', requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'ebony',   label: 'Ebony',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'wax-ash', label: 'Wax ash', requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] },
          { value: 'sable',   label: 'Sable',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] },
          { value: 'walnut',  label: 'Walnut',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] }
        ]
      }
    ]
  },

  /* ----------------------------------------------------------
     Barton
     Three sizes only. Configurable back cushion. Box Edge seat.
     Cover: fixed or loose, plus two bespoke skirt options.
     Three piping options.
     ---------------------------------------------------------- */
  barton: {
    rangeName: 'Barton',
    defaultSize: '2-seater',
    basePriceBySize: {
      'loveseat':    5950,
      '2-seater':    6320,
      '3-seater':    6720
    },
    premiumFabricSurcharge: 200,
    fixed: {
      cushion: { label: 'Seat cushion', value: 'box', display: 'Box edge' }
    },
    groups: [
      {
        key: 'size',
        label: 'Size',
        options: [
          { value: 'loveseat', label: 'Loveseat' },
          { value: '2-seater', label: '2-seater' },
          { value: '3-seater', label: '3-seater' }
        ]
      },
      {
        key: 'fabric',
        label: 'Fabric',
        help: 'Free samples within a week, up to five per request.',
        options: [
          { value: 'plain',   label: 'Plain linen',         priceMultiplier: 1.00 },
          { value: 'striped', label: 'Striped',             priceMultiplier: 1.05 },
          { value: 'floral',  label: 'Floral',              priceMultiplier: 1.12 },
          { value: 'velvet',  label: 'Velvet',              priceMultiplier: 1.15 },
          { value: 'bespoke', label: 'COM (your own fabric)', bespoke: true }
        ]
      },
      {
        key: 'backCushion',
        label: 'Back cushion',
        help: 'Big back is a single tailored cushion. Scatter cushions are smaller, plumper and looser.',
        options: [
          { value: 'scatter',  label: 'Scatter cushions', priceDelta: 90, isDefault: true },
          { value: 'big-back', label: 'Big back',         priceDelta:  0 }
        ]
      },
      {
        key: 'cover',
        label: 'Cover style',
        help: 'Barton is always loose-covered. Skirt options shape the silhouette.',
        /* Pricing tool: Barton has no fixed cover in either market. */
        options: [
          { value: 'loose',    label: 'Loose, dressmaker skirt', priceDelta: 0, isDefault: true },
          { value: 'boxpleat', label: 'Loose, box pleat skirt' },
          { value: 'ruffle',   label: 'Loose, ruffle skirt',     bespoke: true }
        ]
      },
      {
        key: 'frame',
        label: 'Frame',
        help: 'Split-frame arrives in two halves and is assembled in your room. Built for tight access. Loose-cover builds only.',
        options: [
          { value: 'standard', label: 'Standard frame', priceDelta: 0 },
          { value: 'split',    label: 'Split-frame for access', priceDelta: 280, requires: { cover: ['loose', 'boxpleat', 'ruffle'] } }
        ]
      },
      {
        key: 'piping',
        label: 'Piping',
        options: [
          { value: 'self-round',     label: 'Self round',     priceDelta: 140 },
          { value: 'contrast-round', label: 'Contrast round', priceDelta: 180, requiresContrastPairing: true },
          { value: 'soft-edge',      label: 'Soft edge',      priceDelta:  60 }
        ]
      }
      ,
      {
        key: 'cushionFill',
        label: 'Cushion fill',
        help: 'The filling inside the seat cushions.',
        autoHideIfSingle: true,
        options: [
          { value: 'foam-core',            label: 'Foam core',              isDefault: true, markets: ['UK'] },
          { value: 'sustainable-foam-core', label: 'Sustainable foam core', markets: ['UK'] },
          { value: 'all-feather',          label: 'All feather',            markets: ['UK'] },
          { value: 'natural-latex-core',   label: 'Natural latex core',     markets: ['UK'] },
          { value: 'all-feather-down',     label: 'All feather & down',    markets: ['UK'] },
          { value: 'fiber-down-foam',      label: 'Fiber, down and foam',  isDefault: true, markets: ['US'] },
          { value: 'natural-latex-core',   label: 'Natural latex core',     markets: ['US'] }
        ]
      },
      {
        key: 'legStyle',
        label: 'Leg style',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'walcot',     label: 'Walcot' },
          { value: 'draycot',    label: 'Draycot' },
          { value: 'liddington', label: 'Liddington' }
        ]
      },
      {
        key: 'legFinish',
        label: 'Leg finish',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'walnut',  label: 'Walnut',  requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'natural', label: 'Natural', requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'ebony',   label: 'Ebony',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['UK'] },
          { value: 'wax-ash', label: 'Wax ash', requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] },
          { value: 'sable',   label: 'Sable',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] },
          { value: 'walnut',  label: 'Walnut',   requires: { legStyle: ['walcot', 'draycot', 'liddington'] }, markets: ['US'] }
        ]
      }
    ]
  },

  /* ----------------------------------------------------------
     Henrietta
     Standard: Armchair, 3-Seater. Other sizes bespoke only.
     Back: Fixed. Seat: Box Edge. Cover: Fixed only.
     Piping: Self Round or Contrast Round.
     ---------------------------------------------------------- */
  henrietta: {
    rangeName: 'Henrietta',
    defaultSize: '3-seater',
    basePriceBySize: {
      'armchair':  3250,
      '3-seater':  4920
    },
    premiumFabricSurcharge: 200,
    fixed: {
      backCushion: { label: 'Back cushion', value: 'fixed', display: 'Fixed' },
      cushion:     { label: 'Seat cushion', value: 'box',   display: 'Box edge' },
      cover:       { label: 'Cover style',  value: 'fixed', display: 'Fixed cover, no skirt' }
    },
    groups: [
      {
        key: 'size',
        label: 'Size',
        help: 'Armchair and 3-seater are made to order. Other sizes are available as a bespoke conversation.',
        options: [
          { value: 'armchair',   label: 'Armchair' },
          { value: '3-seater',   label: '3-seater' },
          { value: 'loveseat',   label: 'Loveseat',   bespoke: true },
          { value: '2-seater',   label: '2-seater',   bespoke: true },
          { value: '2.5-seater', label: '2.5-seater', bespoke: true },
          { value: '4-seater',   label: '4-seater',   bespoke: true }
        ]
      },
      {
        key: 'fabric',
        label: 'Fabric',
        help: 'Free samples within a week, up to five per request.',
        options: [
          { value: 'plain',   label: 'Plain linen',         priceMultiplier: 1.00 },
          { value: 'striped', label: 'Striped',             priceMultiplier: 1.05 },
          { value: 'floral',  label: 'Floral',              priceMultiplier: 1.12 },
          { value: 'velvet',  label: 'Velvet',              priceMultiplier: 1.15 },
          { value: 'bespoke', label: 'COM (your own fabric)', bespoke: true }
        ]
      },
      {
        key: 'piping',
        label: 'Piping',
        options: [
          { value: 'soft-edge',      label: 'Soft edge',      priceDelta:  60 },
          { value: 'self-round',     label: 'Self round',     priceDelta: 140 },
          { value: 'contrast-round', label: 'Contrast round', priceDelta: 180, requiresContrastPairing: true }
        ]
      }
      ,
      {
        key: 'cushionFill',
        label: 'Cushion fill',
        help: 'The filling inside the seat cushions.',
        autoHideIfSingle: true,
        options: [
          { value: 'natural-latex-core', label: 'Natural latex core', markets: ['UK'] },
          { value: 'all-feather-down',   label: 'All feather & down', isDefault: true, markets: ['UK'] }
        ]
      },
      {
        key: 'legStyle',
        label: 'Leg style',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'henrietta', label: 'Henrietta' }
        ]
      },
      {
        key: 'legFinish',
        label: 'Leg finish',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'mahogany', label: 'Mahogany' }
        ]
      }
    ]
  },

  /* ----------------------------------------------------------
     Sophia
     Three sizes. Everything else fixed: Fixed back, Box Edge seat,
     Fixed cover no skirt, Soft Edge piping. Only Size + Fabric pick.
     ---------------------------------------------------------- */
  sophia: {
    rangeName: 'Sophia',
    defaultSize: '2-seater',
    basePriceBySize: {
      'armchair':  2295,
      '2-seater':  3450,
      '3-seater':  3950
    },
    premiumFabricSurcharge: 200,
    fixed: {
      backCushion: { label: 'Back cushion', value: 'fixed',     display: 'Fixed' },
      cushion:     { label: 'Seat cushion', value: 'box',       display: 'Box edge' },
      cover:       { label: 'Cover style',  value: 'fixed',     display: 'Fixed cover, no skirt' },
      piping:      { label: 'Piping',       value: 'soft-edge', display: 'Soft edge' }
    },
    groups: [
      {
        key: 'size',
        label: 'Size',
        options: [
          { value: 'armchair', label: 'Armchair' },
          { value: '2-seater', label: '2-seater' },
          { value: '3-seater', label: '3-seater' }
        ]
      },
      {
        key: 'fabric',
        label: 'Fabric',
        help: 'Free samples within a week, up to five per request.',
        options: [
          { value: 'plain',   label: 'Plain linen',         priceMultiplier: 1.00 },
          { value: 'striped', label: 'Striped',             priceMultiplier: 1.05 },
          { value: 'floral',  label: 'Floral',              priceMultiplier: 1.12 },
          { value: 'velvet',  label: 'Velvet',              priceMultiplier: 1.15 },
          { value: 'bespoke', label: 'COM (your own fabric)', bespoke: true }
        ]
      }
      ,
      {
        key: 'cushionFill',
        label: 'Cushion fill',
        help: 'The filling inside the seat cushions.',
        autoHideIfSingle: true,
        options: [
          { value: 'foam-core', label: 'Foam core', isDefault: true, markets: ['UK'] }
        ]
      },
      {
        key: 'legStyle',
        label: 'Leg style',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'sophia', label: 'Sophia' }
        ]
      },
      {
        key: 'legFinish',
        label: 'Leg finish',
        help: '',
        autoHideIfSingle: true,
        options: [
          { value: 'mahogany', label: 'Mahogany' }
        ]
      }
    ]
  }
};

/* Stock-now items, with real configurations and lead times */
SC.stockNow = [
  {
    range: 'coco',
    rangeName: 'Coco',
    size: '2.5-seater',
    fabric: 'cool-coconut',
    cushion: 'knife edge',
    cover: 'loose cover',
    price: 5895,
    leadWeeks: 3,
    available: 2,
    image: 'coco-cool-coconut'
  },
  {
    range: 'barton',
    rangeName: 'Barton',
    size: '3-seater',
    fabric: 'snow-drop',
    cushion: 'box edge',
    cover: 'loose cover',
    price: 6720,
    leadWeeks: 4,
    available: 1,
    image: 'barton-snow-drop'
  },
  {
    range: 'isobel',
    rangeName: 'Isobel',
    size: '2-seater',
    fabric: 'beatrice-camelia',
    cushion: 'big back',
    cover: 'loose cover',
    price: 4150,
    leadWeeks: 4,
    available: 3,
    image: 'isobel-beatrice'
  },
  {
    range: 'coco',
    rangeName: 'Coco',
    size: '3-seater',
    fabric: 'dandelion-stripe',
    cushion: 'knife edge',
    cover: 'loose cover',
    price: 6545,
    leadWeeks: 5,
    available: 2,
    image: 'coco-dandelion'
  },
  {
    range: 'felix',
    rangeName: 'Felix',
    size: '2-seater',
    fabric: 'snow-drop',
    cushion: 'fishmouth sprung',
    cover: 'fixed back',
    price: 3895,
    leadWeeks: 5,
    available: 1,
    image: 'felix-snow-drop'
  },
  {
    range: 'coco',
    rangeName: 'Coco Sofa Bed',
    size: '2-seater',
    fabric: 'cool-coconut',
    cushion: 'with mattress',
    cover: 'loose cover',
    price: 7420,
    leadWeeks: 6,
    available: 1,
    image: 'coco-sofabed'
  },
  {
    range: 'coco',
    rangeName: 'Coco Loveseat',
    size: 'loveseat',
    fabric: 'snow-drop',
    cushion: 'knife edge',
    cover: 'loose cover',
    price: 4895,
    leadWeeks: 3,
    available: 2,
    image: 'coco-loveseat-snowdrop'
  },
  {
    range: 'coco',
    rangeName: 'Coco',
    size: '3.5-seater',
    fabric: 'dandelion-stripe',
    cushion: 'knife edge',
    cover: 'loose cover',
    price: 7295,
    leadWeeks: 4,
    available: 1,
    image: 'coco-3-5-dandelion'
  },
  {
    range: 'coco',
    rangeName: 'Coco',
    size: '2.5-seater',
    fabric: 'pelham-moss-velvet',
    cushion: 'knife edge',
    cover: 'tailored cover',
    price: 6750,
    leadWeeks: 6,
    available: 1,
    image: 'coco-pelham-moss-velvet'
  }
];

/* Verbatim reviews from the live theme. Names and dates are real. */
SC.reviews = [
  {
    name: 'Edward Chin',
    date: '1 July 2024',
    location: '',
    headline: 'Great sofa',
    body: "Just got a 3-seater Coco sofa, and it's been a great experience from discovery to delivery. Nadia was brilliant, I visited their showroom in London, and was given all the details I needed about the various options available, with lots of fabric samples to take away. Delivery team was great too. Can't fault anything. Sofa is massively comfortable, feels very well made, looking forwards to nights in.",
    product: 'Coco 3-seater',
    fabric: 'wildwood-ivory'
  },
  {
    name: 'Emma Murphy',
    date: '15 May 2024',
    location: 'USA',
    headline: 'We are swooning over our new loveseat',
    body: "We are swooning over our new loveseat sofa. It's gorgeous and so beyond comfortable. They have nailed it. We also had a wonderful customer service experience from start to finish. Given that we live in the US, I expected it all to be more complicated, but it was easy. We couldn't be happier.",
    product: 'Coco Loveseat',
    fabric: 'magnolia'
  },
  {
    name: 'Nenah Favelle',
    date: '9 June 2024',
    location: 'Scotland',
    headline: 'The most beautiful sofas and exceptional sales',
    body: "I've coveted these beautiful Sophie Conran Sofas on Instagram for some time. When I recently bought a property to renovate into an exclusive-use luxury boutique country house, I knew these were the sofas. I ordered a custom-sized 8-seater corner sofa and two love seats and I am absolutely thrilled with the experience. The team turned around my custom order within just under three weeks and delivered everything to Scotland without a hitch.",
    product: 'Coco 2.5-seater',
    fabric: 'petunia-stripe'
  },
  {
    name: 'Araya',
    date: '28 January 2024',
    location: 'Ohio, USA',
    headline: "I can't thank Nadia and Sophie Conran enough",
    body: "I can't thank Nadia and Sophie Conran enough for such wonderful service. We live in Ohio, USA but the distance is never a problem. Nadia always call and make sure everything is ready for us from start to finish. I feel very comfortable ordering from Sophie Conran even though we don't live in the UK and will order from them again in the future. The couches and pillows are beautiful.",
    product: 'Coco 2.5-seater',
    fabric: 'petunia-stripe'
  }
];

/* Dimensions per product range. Letters A-J match labels on the line drawing.
   When a customer expands the Dimensions section on a product page, the table
   to the right of the diagram reads in the same A-J order. */
SC.dimensions = {
  coco: {
    diagram: 'assets/img/coco-dimensions-diagram.png',
    diagramAlt: 'Coco 2.5-seater dimensions, isometric line drawing with arrows',
    legend: [
      { code: 'A', label: 'External Width' },
      { code: 'B', label: 'External Height' },
      { code: 'C', label: 'External Depth' },
      { code: 'D', label: 'Height With Cushions' },
      { code: 'E', label: 'Feet Height' },
      { code: 'F', label: 'Seat Height' },
      { code: 'G', label: 'Arm Height' },
      { code: 'H', label: 'Seat Width' },
      { code: 'I', label: 'Seat Depth' },
      { code: 'J', label: 'Access Height' }
    ],
    sizes: [
      { name: 'Armchair',   values: { A: 90,  B: 76,  C: 95,  D: 95, E: 8, F: 50, G: 65, H: 62,  I: 60, J: 68 } },
      { name: 'Loveseat',   values: { A: 140, B: 76,  C: 102, D: 95, E: 8, F: 50, G: 76, H: 112, I: 60, J: 68 } },
      { name: '2 Seater',   values: { A: 167, B: 76,  C: 102, D: 95, E: 8, F: 50, G: 76, H: 139, I: 60, J: 68 } },
      { name: '2.5 Seater', values: { A: 196, B: 76,  C: 102, D: 95, E: 8, F: 50, G: 76, H: 168, I: 60, J: 68 } },
      { name: '3 Seater',   values: { A: 224, B: 76,  C: 102, D: 95, E: 8, F: 50, G: 76, H: 196, I: 60, J: 68 } },
      { name: '3.5 Seater', values: { A: 251, B: 76,  C: 102, D: 95, E: 8, F: 50, G: 76, H: 223, I: 60, J: 68 } },
      { name: '4 Seater',   values: { A: 279, B: 76,  C: 102, D: 95, E: 8, F: 50, G: 76, H: 251, I: 60, J: 68 } }
    ]
  },

  /* FELIX dimensions, taken from the live Shopify product specifications.
     The diagram reuses the Coco one for now until a Felix-specific isometric
     is shot — the legend codes match. Lead time on Felix is 8 to 10 weeks. */
  felix: {
    diagram: 'assets/img/coco-dimensions-diagram.png',
    diagramAlt: 'Felix sofa dimensions, isometric line drawing with arrows',
    legend: [
      { code: 'A', label: 'External Width' },
      { code: 'B', label: 'External Height' },
      { code: 'C', label: 'External Depth' },
      { code: 'F', label: 'Seat Height' },
      { code: 'G', label: 'Arm Height' },
      { code: 'H', label: 'Seat Width' },
      { code: 'I', label: 'Seat Depth' },
      { code: 'J', label: 'Access Height' }
    ],
    sizes: [
      { name: 'Armchair', values: { A: 86,  B: 84, C: 99, F: 44, G: 66, H: 66,  I: 65, J: 78 } },
      { name: '2 Seater', values: { A: 156, B: 84, C: 99, F: 44, G: 66, H: 136, I: 65, J: 78 } },
      { name: '3 Seater', values: { A: 196, B: 84, C: 99, F: 44, G: 66, H: 176, I: 65, J: 78 } },
      { name: '4 Seater', values: { A: 236, B: 84, C: 99, F: 44, G: 66, H: 216, I: 65, J: 78 } }
    ]
  }
};

/* Range-level editorial content for product pages.
   Same Coco-level information (materials, frame, springs, fills, care, payment,
   guarantee, lead time) shared across all Coco product variants. Each slab has
   a title, a body, and an image so it reads as a magazine spread, not a spec list. */
SC.productContent = {
  coco: [
    {
      key: 'materials',
      eyebrow: 'What it is made from',
      title: 'Hardwood frame, hand-tied <em>coil springs</em>, feather and down.',
      body: 'A Coco is built around a solid birch frame, mortice-and-tenon jointed by hand. Each spring is hand-tied to the next, the way upholsterers have done it for two hundred years. The seat cushions are feather and down over a fibre core, which you re-plump with a shake. The whole thing is made in our workshop in Long Eaton, Derbyshire.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/articles/Springs_1_9546dce0-5f3e-4c63-a70c-117c6b8d25c9.png?v=1775642165',
      imageAlt: 'Coil springs in a Sophie Conran sofa, hand-tied',
      link: { url: 'https://sophieconran.com/blogs/news/what-lies-beneath-the-springs-inside-our-sofas', label: 'Read about the springs' }
    },
    {
      key: 'fabrics',
      eyebrow: 'Fabrics and finishes',
      title: 'Plain linens, stripes, florals, velvets, <em>or your own</em>.',
      body: 'Choose from a curated range of plain cotton-linens, stripes, florals and velvets, or send us your own cloth for a fully bespoke build. Free fabric samples within a week, up to five per request. The plain cotton-linens are machine-washable at 30°C. Florals and velvets are dry-clean only.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/cool_coconut.webp?v=1719661219&width=900',
      imageAlt: 'Cool Coconut fabric sample, plain cotton-linen',
      link: { url: '#fabrics', label: 'Request free samples' }
    },
    {
      key: 'care',
      eyebrow: 'How to look after it',
      title: 'A sofa that lives longer if you <em>let it</em>.',
      body: 'Loose-cover construction means the cover comes off for cleaning. Plump the cushions weekly. Rotate seat cushions every couple of months so they wear evenly. Spills handled in the first ten minutes almost always come out. For the proper detail, the care guide covers every fabric in the range.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/articles/Coco_Loveseat_with_self_piped_knife-edge_cushions_in_DG_Brera_Lino_Chalk_JR4A1588_286d5600-2274-488a-9bdf-81d9ba52bc19.jpg?v=1777458224',
      imageAlt: 'Coco loveseat with knife-edge cushions in Brera Lino Chalk',
      link: { url: 'https://sophieconran.com/pages/care-guide', label: 'Care guide' }
    },
    {
      key: 'leadtime',
      eyebrow: 'Lead time and delivery',
      title: 'Around eight weeks, often <em>sooner with a stock base</em>.',
      body: 'Made-to-order in the UK takes around 8 weeks from the day fabric is confirmed. If we have a stock base in your size, that comes down to 3 to 6 weeks. US orders take 10 to 14 weeks at the moment, ahead of the US stock-base programme coming on later this year. Delivery is by two-person team, into your room, fully unwrapped and inspected.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/articles/Factory_Still_-_Fabrics_b49b46bf-9761-4ea2-a2d8-c71ab5b4046b.jpg?v=1777903513',
      imageAlt: 'Inside the Sophie Conran workshop, fabrics ready to cut'
    },
    {
      key: 'guarantee',
      eyebrow: 'What is covered',
      title: 'Twenty-five year frame guarantee, <em>five on everything else</em>.',
      body: 'The hardwood frame is guaranteed for twenty-five years. Springs, fills, fabrics and feet are covered for five years against manufacturing defects. We don\'t cover wear from family life, because that\'s what good sofas do. If anything goes wrong, the workshop will repair, replace, or refund.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/articles/Sofa_Patterns.jpg?v=1775126055',
      imageAlt: 'Sofa patterns laid out on the workshop floor'
    },
    {
      key: 'payment',
      eyebrow: 'How to pay',
      title: 'Card, bank transfer, <em>or interest-free instalments</em>.',
      body: 'Pay in full at order or split into three or six interest-free instalments via Klarna. For bespoke orders over £8,000 we accept bank transfer with a 30% deposit and the balance on completion. All prices include VAT.',
      image: 'https://cdn.sophieconran.com/renders/KCOS25K-O1421-FR-Coco-2.5%20Seater-Capelo%20Snow%20Drop.png',
      imageAlt: 'Coco 2.5 Seater in Capelo Snow Drop'
    }
  ],

  /* FELIX editorial slabs. Felix is a different construction story from
     Coco: fish-mouth steel spring base rather than hand-tied coil; foam-
     wrapped feather seat cushion rather than feather-and-down; available
     in fixed or loose cover. Built in Lancashire, not Long Eaton. */
  felix: [
    {
      key: 'materials',
      eyebrow: 'What it is made from',
      title: 'Hardwood frame, fish-mouth <em>sprung base</em>, feather-wrapped foam.',
      body: 'Felix sits on a solid hardwood frame with a fish-mouth steel sprung seat platform. The seat cushion is a foam core wrapped in a feather and down mix, which holds its shape with minimal plumping. The back cushion is all-feather: duck feather and goose down for that deep, lived-in softness. Hand-built in Lancashire by upholsterers we have worked with for years.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/Sophie_Conran_Felix_3_seater_sofa_in_Natural_Linen_-_Cool_Coconut.jpg?v=1764337503&width=900',
      imageAlt: 'Felix 3-seater detail in Cool Coconut'
    },
    {
      key: 'fabrics',
      eyebrow: 'Fabrics and finishes',
      title: 'Plains, stripes, florals, <em>or your own</em>.',
      body: 'Felix is offered in a curated palette of cotton-linen plains, GOTS-certified organic cotton stripes, and a small floral edit, with full bespoke available. Stripes are machine-washable. Plain cotton-linens are machine-washable. Florals are dry-clean only. Free fabric samples within a week, up to five per request.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/Sophie_Conran_Felix_4_Seater_loose_cover_in_Caramel_Stripe_1_Front.png?v=1777886452&width=900',
      imageAlt: 'Felix in Caramel Stripe',
      link: { url: '#fabrics', label: 'Request free samples' }
    },
    {
      key: 'cover',
      eyebrow: 'Loose or fixed',
      title: 'Pick the cover that <em>suits the way you live</em>.',
      body: 'Felix is available in two cover styles. A removable loose cover that comes off for cleaning, with bow ties to help slide it on and off. Many of our customers buy a second set of covers, so they can refresh a room without buying a new sofa. Or a fully upholstered fixed cover, for a cleaner, more tailored line. Both use exactly the same frame, springs and cushions.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/Sophie_Conran_Felix_3_seater_sofa_in_Natural_Linen_-_Rosedale_-_Front_01_cc96a3cf-efc2-4775-b878-8c3b973adb99.jpg?v=1764337690&width=900',
      imageAlt: 'Felix 3-seater in Rosedale'
    },
    {
      key: 'leadtime',
      eyebrow: 'Lead time and delivery',
      title: 'Around 8 to 10 weeks, <em>often sooner</em>.',
      body: 'Standard Felix lead time is 8 to 10 weeks from order. We deliver in our own vehicles with our own team, who will assemble the sofa in your room. All our sofas can be made in sectional parts at no extra charge if access is tight — flag this when you order and we will plan accordingly.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/Felix-large-duckegg-front.png?v=1772050754&width=900',
      imageAlt: 'Felix 3-seater in Wildwood Duck Egg'
    },
    {
      key: 'guarantee',
      eyebrow: 'How long it should last',
      title: '25-year <em>frame guarantee</em>.',
      body: 'A 25-year guarantee on the frame. The cushions and covers carry a two-year guarantee, but they will last very much longer than that if you follow the care guide. We keep records of every build, so if anything goes wrong we can fix it from the original spec.',
      image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/Felix-large-ivory-front.png?v=1772050754&width=900',
      imageAlt: 'Felix 3-seater in Wildwood Ivory'
    }
  ]
};

/* The Scalloped bed linen range, eight colours, real prices */
SC.bedLinen = [
  { handle: 'navy',   name: 'Navy Scalloped',   sizes: 'Single to Emperor',   fromPrice: 121.55, swatch: '#1B2D4A' },
  { handle: 'white',  name: 'White Scalloped',  sizes: 'Single to Emperor',   fromPrice: 121.55, swatch: '#F5EFE3' },
  { handle: 'pink',   name: 'Pink Scalloped',   sizes: 'Single to Super King',fromPrice: 121.55, swatch: '#E8C4C0' },
  { handle: 'green',  name: 'Green Scalloped',  sizes: 'Double, King',        fromPrice: 166.60, swatch: '#7A8B6F' },
  { handle: 'blue',   name: 'Blue Scalloped',   sizes: 'Double to Super King',fromPrice: 166.60, swatch: '#A8C0BC' },
  { handle: 'red',    name: 'Red Scalloped',    sizes: 'Single to Super King',fromPrice: 121.55, swatch: '#B56A4F' },
  { handle: 'coral',  name: 'Coral Scalloped',  sizes: 'Single duvet cover',  fromPrice: 73.50,  swatch: '#E89A7A' },
  { handle: 'orange', name: 'Orange Scalloped', sizes: 'Single, Emperor',     fromPrice: 73.50,  swatch: '#D89060' }
];

/* Cocobella fabrics at John Lewis */
SC.cocobellaFabrics = [
  { fabric: 'coastal-blue-stripe',  size: '3.5-seater', sizesAvailable: 'all sizes' },
  { fabric: 'cornish-blue-stripe',  size: '3.5-seater', sizesAvailable: 'all sizes' },
  { fabric: 'olive-green-stripe',   size: '3-seater',   sizesAvailable: 'all sizes' },
  { fabric: 'petunia-stripe',       size: '3.5-seater', sizesAvailable: 'all sizes' },
  { fabric: 'beatrice-camelia',     size: '3.5-seater', sizesAvailable: 'all sizes' },
  { fabric: 'beatrice-olive',       size: '2.5-seater', sizesAvailable: 'all sizes' },
  { fabric: 'beatrice-midnight',    size: '2.5-seater', sizesAvailable: 'all sizes' },
  { fabric: 'arona-denim',          size: 'plain',      sizesAvailable: 'all sizes' }
];

/* Sophie Conran for Portmeirion collections */
SC.portmeirionCollections = [
  { handle: 'white-porcelain', name: 'White Porcelain', desc: 'The original 2006 range. Coupe and rimmed. Mugs, bowls, plates, bistro pieces.', colour: '#F5EFE3', accent: '#D8D2C5', url: 'https://sophieconran.com/collections/white-porcelain' },
  { handle: 'floret', name: 'Floret', desc: 'Painted floral motif. Available in Grey, Robin\'s Egg, Cream.', colour: '#A8C0BC', accent: '#7A9590', url: 'https://sophieconran.com/collections/floret' },
  { handle: 'arbor', name: 'Arbor', desc: 'Trellis-inspired. Robin\'s Egg and Cream colourways.', colour: '#B5C9C5', accent: '#7A8B6F', url: 'https://sophieconran.com/collections/arbor' },
  { handle: 'honey-pot', name: 'Honey Pot mugs', desc: 'Five colourways: Pink, Celadon, Mulberry, Sunshine, and the original.', colour: '#E8C0A8', accent: '#B89A5E', url: 'https://sophieconran.com/collections/honey-pot' },
  { handle: 'celadon', name: 'Celadon', desc: 'Soft sage-green palette. Mugs, cereal bowls, dinner pieces.', colour: '#9CB0A0', accent: '#7A8B6F', url: 'https://sophieconran.com/collections/celadon' },
  { handle: 'lavandula', name: 'Lavandula', desc: 'Lavender-toned ceramics, also available as placemats and serving sets on this site.', colour: '#C0B5C8', accent: '#9085A0', url: 'https://sophieconran.com/collections/lavandula' }
];

/* PORTMEIRION BESTSELLERS — twenty years of plates and bowls that
   keep selling. Pulled live from Shopify and ordered by 90-day gross
   sales (analytics run 13 May 2026). Imagery is from ACTIVE products
   in the live store (vendor: Sophie Conran for Portmeirion UK), not
   the legacy "OLD" duplicates. Each row carries:
     id            stable favourites key (prefix pm- so they live in
                   their own namespace next to gallery sofa pins)
     range         display name on the card (the product itself)
     fabric        the secondary line under the title; for tableware
                   this is the collection name (White Porcelain,
                   Lavandula, Mistletoe, etc) — same component slot,
                   different semantic
     image         CDN URL keyed in sc-images.js portmeirionBestsellers
     alt           accessibility label
     priceFrom     £ price (includes VAT, UK pricing)
     swatch        small dot on the card; the collection's signature
                   colour from portmeirionCollections, or a sensible
                   accent for the seasonal/scent ranges
     collection    filter key: white / lavandula / arbor / mistletoe /
                   honey / candles / textiles
     weeks         lead time. Portmeirion ships drop-ship in 2–4
                   working days, so we mark as 0 (= "Ready to ship"
                   in the gallery formatter)
     tags          favourites system tags — 'tabletop' triggers the
                   "From £" prefix and removes the "Made to order"
                   line; collection tag for cross-references
   The order here is the order they render. */
SC.portmeirionBestsellers = [
  /* === WHITE PORCELAIN — the original range, twenty years in === */
  { id: 'pm-white-12pc',         handle: 'white-porcelain-twelve-piece-dining-set', range: 'White Porcelain Twelve Piece Dining Set',     fabric: 'White Porcelain · for four',           image: 'white-12pc',         priceFrom: 144.00, swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-pasta',        handle: 'white-porcelain-pasta-bowl-set-of-four',  range: 'White Porcelain Pasta Bowls',                 fabric: 'White Porcelain · set of four',        image: 'white-pasta',        priceFrom: 62.40,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-dinner',       handle: 'white-porcelain-dinner-plate-set-of-four', range: 'White Porcelain Dinner Plates',              fabric: 'White Porcelain · set of four',        image: 'white-dinner',       priceFrom: 62.40,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-coupe-side',   handle: 'white-porcelain-coupe-side-plates-set-of-four', range: 'White Porcelain Coupe Side Plates',     fabric: 'White Porcelain · set of four',        image: 'white-coupe-dinner', priceFrom: 33.60,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-mugs',         handle: 'white-porcelain-classic-mugs-set-of-four', range: 'White Porcelain Classic Mugs',               fabric: 'White Porcelain · set of four',        image: 'white-mugs',         priceFrom: 40.00,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-soup',         handle: 'white-porcelain-rimmed-soup-plate-set-of-four', range: 'White Porcelain Rimmed Soup Plates',    fabric: 'White Porcelain · set of four',        image: 'white-soup',         priceFrom: 47.60,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-cereal',       handle: 'white-porcelain-cereal-bowls-set-of-four', range: 'White Porcelain Cereal Bowls',               fabric: 'White Porcelain · set of four',        image: 'white-cereal',       priceFrom: 32.20,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-tea',          handle: 'white-porcelain-tea-cup-saucer-set-of-four', range: 'White Porcelain Tea Cup & Saucer',         fabric: 'White Porcelain · set of four',        image: 'white-tea',          priceFrom: 81.60,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-statement',    handle: 'white-porcelain-large-statement-bowl',    range: 'White Porcelain Large Statement Bowl',        fabric: 'White Porcelain · serving',            image: 'white-statement',    priceFrom: 55.60,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-cake-stand',   handle: 'white-porcelain-cake-stand',              range: 'White Porcelain Cake Stand',                  fabric: 'White Porcelain · footed',             image: 'white-cake-stand',   priceFrom: 50.80,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-bistro',       handle: 'white-porcelain-bistro-bowl-set-of-two',  range: 'White Porcelain Bistro Bowls',                fabric: 'White Porcelain · set of two',         image: 'white-bistro',       priceFrom: 42.40,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-three-bowl',   handle: 'white-porcelain-three-bowls-tray-set',    range: 'White Porcelain Three Bowls & Tray',          fabric: 'White Porcelain · serving',            image: 'white-three-bowl',   priceFrom: 41.60,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-roast-round',  handle: 'white-porcelain-round-roasting-dish',     range: 'White Porcelain Round Roasting Dish',         fabric: 'White Porcelain · 28cm',               image: 'white-roast-round',  priceFrom: 46.00,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-roast-rect',   handle: 'white-porcelain-small-rectangular-roasting-dish', range: 'White Porcelain Rectangular Roasting Dish', fabric: 'White Porcelain · small',           image: 'white-roast-rect',   priceFrom: 34.00,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-mixing',       handle: 'white-porcelain-medium-mixing-bowl',      range: 'White Porcelain Mixing Bowl',                 fabric: 'White Porcelain · medium',              image: 'white-mixing',       priceFrom: 43.00,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-salad-med',    handle: 'white-porcelain-medium-salad-bowl',       range: 'White Porcelain Medium Salad Bowl',           fabric: 'White Porcelain · 26cm',               image: 'white-salad-med',    priceFrom: 32.00,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },
  { id: 'pm-white-casserole',    handle: 'white-porcelain-small-oval-casserole',    range: 'White Porcelain Small Oval Casserole',        fabric: 'White Porcelain · oven-to-table',      image: 'casserole-oval',     priceFrom: 47.20,  swatch: '#F5EFE3', collection: 'white',     weeks: 0, tags: ['tabletop','portmeirion','white-porcelain'] },

  /* === LAVANDULA — the newest range, painted lavender sprigs === */
  { id: 'pm-lav-pasta',          handle: 'lavandula-pasta-bowls-set-of-four',       range: 'Lavandula Pasta Bowls',                       fabric: 'Lavandula · set of four',              image: 'lav-pasta',          priceFrom: 72.00,  swatch: '#C0B5C8', collection: 'lavandula', weeks: 0, tags: ['tabletop','portmeirion','lavandula'] },
  { id: 'pm-lav-dinner',         handle: 'lavandula-dinner-plates-set-of-four',     range: 'Lavandula Dinner Plates',                     fabric: 'Lavandula · set of four',              image: 'lav-dinner',         priceFrom: 72.00,  swatch: '#C0B5C8', collection: 'lavandula', weeks: 0, tags: ['tabletop','portmeirion','lavandula'] },
  { id: 'pm-lav-side',           handle: 'lavandula-side-plates-set-of-four',       range: 'Lavandula Side Plates',                       fabric: 'Lavandula · set of four',              image: 'lav-side',           priceFrom: 54.40,  swatch: '#C0B5C8', collection: 'lavandula', weeks: 0, tags: ['tabletop','portmeirion','lavandula'] },
  { id: 'pm-lav-cereal',         handle: 'lavandula-cereal-bowls-set-of-four',      range: 'Lavandula Cereal Bowls',                      fabric: 'Lavandula · set of four',              image: 'lav-cereal',         priceFrom: 54.40,  swatch: '#C0B5C8', collection: 'lavandula', weeks: 0, tags: ['tabletop','portmeirion','lavandula'] },
  { id: 'pm-lav-tea',            handle: 'lavandula-tea-plates-set-of-four',        range: 'Lavandula Tea Plates',                        fabric: 'Lavandula · set of four',              image: 'lav-tea',            priceFrom: 40.00,  swatch: '#C0B5C8', collection: 'lavandula', weeks: 0, tags: ['tabletop','portmeirion','lavandula'] },
  { id: 'pm-lav-mugs',           handle: 'lavandula-mugs-set-of-two',               range: 'Lavandula Mugs',                              fabric: 'Lavandula · set of two',               image: 'lav-mugs',           priceFrom: 28.00,  swatch: '#C0B5C8', collection: 'lavandula', weeks: 0, tags: ['tabletop','portmeirion','lavandula'] },
  { id: 'pm-lav-cake',           handle: 'lavandula-footed-cake-stand',             range: 'Lavandula Footed Cake Stand',                 fabric: 'Lavandula · serving',                  image: 'lav-cake',           priceFrom: 55.60,  swatch: '#C0B5C8', collection: 'lavandula', weeks: 0, tags: ['tabletop','portmeirion','lavandula'] },
  { id: 'pm-lav-runner',         handle: 'lavandula-table-runner',                  range: 'Lavandula Table Runner',                      fabric: 'Lavandula · 100% cotton',              image: 'lav-runner',         priceFrom: 23.20,  swatch: '#C0B5C8', collection: 'textiles',  weeks: 0, tags: ['tabletop','portmeirion','lavandula','textiles'] },
  { id: 'pm-lav-napkins',        handle: 'lavandula-napkins-set-of-two',            range: 'Lavandula Napkins',                           fabric: 'Lavandula · set of two',               image: 'lav-napkins',        priceFrom: 10.80,  swatch: '#C0B5C8', collection: 'textiles',  weeks: 0, tags: ['tabletop','portmeirion','lavandula','textiles'] },

  /* === HONEY POT — the ten-year mug shape, five colourways === */
  { id: 'pm-honey-pink',         handle: 'pink-honey-pot-mug-set-of-four',          range: 'Pink Honey Pot Mugs',                         fabric: 'Honey Pot · set of four',              image: 'honey-pink',         priceFrom: 40.00,  swatch: '#E8C0A8', collection: 'honey',     weeks: 0, tags: ['tabletop','portmeirion','honey-pot'] },

  /* === ARBOR — trellis motif, cream and grey === */
  { id: 'pm-arbor-cream',        handle: 'cream-arbor-dinner-plate-set-of-four',    range: 'Cream Arbor Dinner Plates',                   fabric: 'Arbor · set of four',                  image: 'arbor-cream',        priceFrom: 56.00,  swatch: '#E8E0CD', collection: 'arbor',     weeks: 0, tags: ['tabletop','portmeirion','arbor'] },

  /* === MISTLETOE / AMOR — seasonal table textiles === */
  { id: 'pm-mistletoe-cloth',    handle: 'amor-porcelain-table-cloth',              range: 'Amor Mistletoe Tablecloth',                   fabric: 'Mistletoe · 100% cotton',              image: 'mistletoe-cloth',    priceFrom: 40.80,  swatch: '#A8BCA0', collection: 'textiles',  weeks: 0, tags: ['tabletop','portmeirion','mistletoe','textiles'] },
  { id: 'pm-placemat-grey',      handle: 'dove-grey-textile-placemat-set-of-two',   range: 'Dove Grey Textile Placemats',                 fabric: 'Textiles · set of two',                image: 'placemat-grey',      priceFrom: 11.20,  swatch: '#C7C2B6', collection: 'textiles',  weeks: 0, tags: ['tabletop','portmeirion','textiles'] },

  /* === CANDLES & DIFFUSERS — chakra-themed home fragrance === */
  { id: 'pm-candle-frank',       handle: 'frankincense-vetivert-ceramic-candle',    range: 'Frankincense & Vetivert Candle',              fabric: 'Ceramic candle · Wisdom',              image: 'candle-frank',       priceFrom: 18.70,  swatch: '#B89A5E', collection: 'candles',   weeks: 0, tags: ['tabletop','portmeirion','candles'] },
  { id: 'pm-diffuser-pink',      handle: 'pink-pepper-neroli-reed-diffuser',        range: 'Pink Pepper & Neroli Reed Diffuser',          fabric: 'Reed diffuser · Freedom',              image: 'diffuser-pink',      priceFrom: 20.40,  swatch: '#E8C0A8', collection: 'candles',   weeks: 0, tags: ['tabletop','portmeirion','candles'] }
];

/* Sophie's World moodboard items.
   Each item declares its content type, its grid placement (cols / rows at
   desktop), and an optional small tilt for the scrapbook feel. Items render
   in this order at desktop, flatten to a single column at mobile.
   Mixed media: real articles from the Shopify journal, fake Instagram tiles
   (swap for a real embed at Shopify time), pull quotes in Sophie's voice. */
SC.sophiesWorldItems = [
  {
    type: 'article',
    key: 'a-sofa-without-the-chemicals',
    cols: 4, rows: 2,
    tilt: -0.8,
    caption: 'Letter from Sophie · workshop'
  },
  {
    type: 'quote',
    quote: 'What is inside a sofa matters as much as what is on the outside.',
    attribution: 'Sophie Conran',
    cols: 2, rows: 2,
    tone: 'navy',
    tilt: 1.2
  },
  {
    type: 'article',
    key: 'sophies-classic-fish-pie',
    cols: 2, rows: 2,
    tilt: 0.6,
    caption: 'Sophie\'s kitchen · recipe'
  },
  {
    type: 'instagram',
    handle: '@sophieconranofficial',
    permalink: 'https://www.instagram.com/sophieconranofficial/',
    image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/34245410_8_cfa5544c-ac85-4972-9473-51d3e5412881.jpg?v=1728471720&width=900',
    caption: 'In the studio this morning, choosing fabrics for the new Beatrice range. The Camelia keeps winning.',
    isVideo: false,
    cols: 2, rows: 2,
    tilt: -0.4
  },
  {
    type: 'article',
    key: 'what-lies-beneath-the-springs-inside-our-sofas',
    cols: 2, rows: 1,
    tilt: 0.4,
    caption: 'Workshop · 8 min read'
  },
  {
    type: 'instagram',
    handle: '@sophieconranofficial',
    permalink: 'https://www.instagram.com/sophieconranofficial/',
    image: 'https://cdn.sophieconran.com/renders/KCOS25K-O1421-FR-Coco-2.5%20Seater-Capelo%20Snow%20Drop.png',
    caption: 'The Coco in Capelo Snow Drop. Almost too easy to live with.',
    isVideo: true,
    cols: 2, rows: 2,
    tilt: 0.8
  },
  {
    type: 'quote',
    quote: 'A sofa is a place to read, sleep, eat, talk. Build it for that.',
    attribution: 'Sophie',
    cols: 4, rows: 1,
    tone: 'cream',
    tilt: -0.6
  },
  {
    type: 'article',
    key: 'the-ultimate-tarte-tatin',
    cols: 3, rows: 2,
    tilt: 0.5,
    caption: 'Sophie\'s kitchen · recipe'
  },
  {
    type: 'instagram',
    handle: '@sophieconranofficial',
    permalink: 'https://www.instagram.com/sophieconranofficial/',
    image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/green-scallop-corner-web_4.webp?width=600',
    caption: 'The Green Scalloped, made for late spring mornings.',
    isVideo: false,
    cols: 3, rows: 2,
    tilt: -0.5
  },
  {
    type: 'article',
    key: 'why-does-a-locally-made-sofa-cost-more',
    cols: 3, rows: 1,
    tilt: 0.3,
    caption: 'Journal · pricing'
  },
  {
    type: 'instagram',
    handle: '@sophieconranofficial',
    permalink: 'https://www.instagram.com/sophieconranofficial/',
    image: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/Portmeirion_Banner_1920x_014c7790-2703-414f-9d25-b19e54525bf7.webp?width=600',
    caption: 'Twenty years of Sophie Conran for Portmeirion. Six collections, one quiet thread.',
    isVideo: false,
    cols: 3, rows: 1,
    tilt: -0.3
  },
  {
    type: 'article',
    key: 'understanding-cushion-styles',
    cols: 2, rows: 2,
    tilt: 0.7,
    caption: 'Workshop · sofa anatomy'
  },
  {
    type: 'quote',
    quote: 'Anyone can sell you a sofa. Fewer can tell you why theirs will still be in your living room in twenty years.',
    attribution: '',
    cols: 4, rows: 2,
    tone: 'gold',
    tilt: -0.4
  }
];
SC.sophieTableware = [
  { name: 'Lavandula Placemats', detail: 'Set of six', price: 30.00, colour: '#C0B5C8' },
  { name: 'Amor Porcelain Dinner Plate', detail: 'Set of four', price: 72.00, colour: '#F5EFE3' },
  { name: 'Lavandula Pasta Bowls', detail: 'Set of four', price: 72.00, colour: '#C0B5C8' },
  { name: 'Honey Pot Mugs', detail: 'Set of four, several colourways', price: 40.00, colour: '#E8C0A8' }
];

/* Trade portal: Helen's mock account */
SC.tradeAccount = {
  name: 'Helen Carter',
  practice: 'Carter Interiors',
  accountManager: 'Adam Wright',
  activeQuotes: 3,
  ordersInProduction: 1,
  ytdVolume: 42580,
  trade: [
    { range: 'coco',       size: '3-seater',   trade: 4420 },
    { range: 'barton',     size: '3-seater',   trade: 5180 },
    { range: 'henrietta',  size: '2.5-seater', trade: 4920 },
    { range: 'isobel',     size: '2-seater',   trade: 2890 }
  ]
};

/* Lead time strings, editable in the live theme via settings */
SC.leadTime = {
  uk: 'Around 8 weeks from order, often sooner.',
  us: 'Around 10 to 14 weeks until the stock-base programme rolls out.'
};

/* Helper formatters */
SC.fmt = {
  price: function(n, currency) {
    currency = currency || '£';
    if (n == null) return '';
    return currency + n.toLocaleString('en-GB', { minimumFractionDigits: n % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  },
  gbp: function(n) {
    if (n == null) return '';
    return '£' + n.toLocaleString('en-GB', { minimumFractionDigits: n % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
  },
  fabricSwatch: function(handle, size) {
    var f = SC.fabrics[handle];
    if (!f) return '';
    size = size || 24;
    if (f.print === 'stripe') {
      return '<span class="sc-swatch" style="width:' + size + 'px;height:' + size + 'px;background:repeating-linear-gradient(90deg,' + f.swatchColour + ' 0 4px,' + f.swatchAccent + ' 4px 7px);"></span>';
    }
    if (f.print === 'floral') {
      return '<span class="sc-swatch" style="width:' + size + 'px;height:' + size + 'px;background:radial-gradient(circle at 30% 30%,' + f.swatchAccent + ' 0 3px,transparent 4px),radial-gradient(circle at 70% 70%,' + f.swatchAccent + ' 0 3px,transparent 4px),' + f.swatchColour + ';"></span>';
    }
    return '<span class="sc-swatch" style="width:' + size + 'px;height:' + size + 'px;background:' + f.swatchColour + ';"></span>';
  }
};

/* ============================================================
   SCALLOPED COLLECTION — full product catalogue
   ============================================================
   The eight-colour Scalloped range, modelled for the new collection
   product page. Each colour declares its four product types
   (duvet cover, oxford pillowcase, square pillowcase, super king
   pillowcase) with the live Shopify SKUs, prices and images.

   Real SKUs from Shopify (sophieconran.com store). Where a particular
   size in a colour isn't in stock or isn't carried, the entry is
   omitted from that colour's sizes array, which the PDP renders as
   "out of stock" rather than missing entirely.

   Pillowcases are sold individually. The PDP defaults quantity to 2
   for Oxford pillowcases, since most beds need a pair. ============================================================ */
SC.scallopedCollection = {
  /* Display name used in titles and the colour pill. */
  rangeName: 'Scalloped',
  rangeSlug: 'scalloped',
  rangeStrap: 'Hand-finished scalloped edge. Pure cotton.',

  /* Eight colour entries. Each links to the live Shopify hero image
     (one per colour), an editorial gallery, the swatch hex, and a
     short Sophie-voice copy line per colour for the editorial panel. */
  colours: [
    {
      handle: 'navy',
      name: 'Navy',
      swatch: '#1B2D4A',
      textOn: 'light', /* swatch contrast: 'light' or 'dark' text on swatch */
      copy: 'A grown-up Navy that reads almost black at night and settles into a deep, calm blue in daylight. The most-bought colour, and the easiest to live with.',
      heroImage: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/NavyScallopSingle.jpg?width=1800',
      heroAlt: 'Navy Scalloped bed linen styled on a single bed',
      /* Mixed shot types: lifestyle bed > Oxford cut-out > corner detail > styled close-up.
         Each thumbnail reads visually distinct from its neighbours. */
      gallery: [
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/NavyScallopSingle.jpg?width=1800',                                  alt: 'Navy Scalloped on a styled single bed' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/Navy-Scallop-Square-Pillowcase-CutoutACSCASQUNVY.jpg?width=1400',   alt: 'Navy Scalloped Square pillowcase, cut-out' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/navy-scalloped-bed-linen-collection-web-opt_4.webp?width=1400',     alt: 'Navy Scalloped scalloped-edge close-up' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/navy-scalloped-bed-linen-collection-web-opt_1.webp?width=1400',     alt: 'Navy Scalloped duvet cover corner' }
      ]
    },
    {
      handle: 'white',
      name: 'White',
      swatch: '#F5EFE3',
      textOn: 'dark',
      copy: 'Pure White with a hand-stitched scallop in matching thread. The one to start with if you mix fabrics, or the one to stay with if you do not.',
      heroImage: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/white-scallop-corner-web_1.webp?width=1800',
      heroAlt: 'White Scalloped duvet cover corner detail',
      gallery: [
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/white-scallop-corner-web_1.webp?width=1800',                 alt: 'White Scalloped duvet cover corner' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/white-scalloped-bed-linen-web-opt-v2_4.webp?width=1400',     alt: 'White Scalloped Oxford pillowcase, cut-out' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/white-scallop-square-pillowcase-web_1.webp?width=1400',       alt: 'White Scalloped Square pillowcase, cut-out' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/white-scallop-corner-web_4.webp?width=1400',                  alt: 'White Scalloped scallop edge close-up' }
      ]
    },
    {
      handle: 'pink',
      name: 'Pink',
      swatch: '#E8C4C0',
      textOn: 'dark',
      copy: 'A soft, warm Pink. Reads as a neutral against most wall colours, surprisingly grown-up next to dark wood or rattan.',
      heroImage: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/pink-scallop-single-bed-linen-collection-web-opt-lifestyle_1.webp?width=1800',
      heroAlt: 'Pink Scalloped bed linen on a styled single bed',
      gallery: [
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/pink-scallop-single-bed-linen-collection-web-opt-lifestyle_1.webp?width=1800',                alt: 'Pink Scalloped styled single bed' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/pink-scallop-bed-linen-web-opt2_acl_5d2d6597-c518-4e7d-9d0b-e82b91725f0d.webp?width=1400', alt: 'Pink Scalloped Oxford pillowcase, cut-out' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/pink-scallop-bed-linen-web-opt2_acl_1__4.webp?width=1400',                                  alt: 'Pink Scalloped Square pillowcase, cut-out' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/pink-scallop-bed-linen-web-opt_1.webp?width=1400',                                          alt: 'Pink Scalloped duvet cover detail' }
      ]
    },
    {
      handle: 'green',
      name: 'Green',
      swatch: '#7A8B6F',
      textOn: 'light',
      copy: 'A soft sage Green that does what plants do for a room. Goes beautifully with old wood, cream walls, and linen curtains.',
      heroImage: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/closeup-green-scallop-bed-web-optimised-lifestyle_1.webp?width=1800',
      heroAlt: 'Green Scalloped bed linen on a made bed',
      gallery: [
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/closeup-green-scallop-bed-web-optimised-lifestyle_1.webp?width=1800',  alt: 'Green Scalloped bed, close-up lifestyle' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/green-scallop-pillowcases-web-optimised-lifestyle.webp?width=1400',    alt: 'Green Scalloped Oxford pillowcases on a bed' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/green-scallop-corner-web_4.webp?width=1400',                            alt: 'Green Scalloped duvet cover corner' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/green-scallop-pillowcases-web-optimised-lifestyle_1.webp?width=1400',  alt: 'Green Scalloped Square pillowcase styled' }
      ]
    },
    {
      handle: 'blue',
      name: 'Blue',
      swatch: '#A8C0BC',
      textOn: 'dark',
      copy: 'A washed-out, sea-glass Blue. Cool without being cold. Loved by rooms that face east and catch the early light.',
      heroImage: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/blue-scalloped-bed-linen-collection_lifestyle-web-opt_5.webp?width=1800',
      heroAlt: 'Blue Scalloped bed linen on a made bed',
      gallery: [
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/blue-scalloped-bed-linen-collection_lifestyle-web-opt_5.webp?width=1800', alt: 'Blue Scalloped lifestyle bed' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/blue-scallop-single-bed-linen-collection-web-opt-lifestyle.jpg_1.webp?width=1400', alt: 'Blue Scalloped styled single bed' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/blue-scalloped-bed-linen-collection_lifestyle-web-opt_2.webp?width=1400', alt: 'Blue Scalloped Super King pillowcase' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/blue-scalloped-bed-linen-collection_lifestyle-web-opt_3.webp?width=1400', alt: 'Blue Scalloped Square pillowcase, cut-out' }
      ]
    },
    {
      handle: 'red',
      name: 'Red',
      swatch: '#B56A4F',
      textOn: 'light',
      copy: 'A warm, terracotta-leaning Red. Dramatic against white walls, gentle against cream. Good in winter, surprising in summer.',
      heroImage: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/red_single_scallop.webp?width=1800',
      heroAlt: 'Red Scalloped bed linen, styled single bed',
      gallery: [
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/red_single_scallop.webp?width=1800',                                            alt: 'Red Scalloped styled single bed' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/red_scalloped_bed_linen_oxford_pillow_case_cut_out_web_opt_1.webp?width=1400', alt: 'Red Scalloped Oxford pillowcase, cut-out' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/red_scalloped_bed_linen_square_pillow_case_cut_out_web_opt.webp?width=1400',   alt: 'Red Scalloped Square pillowcase, cut-out' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/red-scallop-bed-linen---web-opt_2.webp?width=1400',                             alt: 'Red Scalloped duvet cover lifestyle' }
      ]
    },
    {
      handle: 'coral',
      name: 'Coral',
      swatch: '#E89A7A',
      textOn: 'dark',
      copy: 'A soft, sun-faded Coral. Lighter than the Red. The colour of a Greek island at five in the afternoon.',
      heroImage: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/coral-scalloped-bed-linen-web-opt-v2_3.webp?width=1800',
      heroAlt: 'Coral Scalloped bed linen, lifestyle',
      gallery: [
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/coral-scalloped-bed-linen-web-opt-v2_3.webp?width=1800', alt: 'Coral Scalloped lifestyle bed' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/coral-scalloped-bed-linen-web-opt-v2.webp?width=1400',   alt: 'Coral Scalloped Oxford pillowcase, cut-out' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/coral-scalloped-bed-linen-web-opt-v2_1.webp?width=1400', alt: 'Coral Scalloped Square pillowcase, cut-out' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/coral-scalloped-bed-linen-web-opt-v2_2.webp?width=1400', alt: 'Coral Scalloped duvet cover styled' }
      ]
    },
    {
      handle: 'orange',
      name: 'Orange',
      swatch: '#D89060',
      textOn: 'light',
      copy: 'The brightest of the eight. A clean, summer Orange. Brilliant in a guest room or anywhere you want a lift on a grey morning.',
      heroImage: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/orange-scallop-and-wall-hanging---web-opt_1_2.webp?width=1800',
      heroAlt: 'Orange Scalloped bed linen, styled',
      gallery: [
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/orange-scallop-and-wall-hanging---web-opt_1_2.webp?width=1800', alt: 'Orange Scalloped styled bed' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/orange_scallop_single__1.webp?width=1400',                       alt: 'Orange Scalloped styled single bed' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/orange_scallop_-_web_opt.webp?width=1400',                       alt: 'Orange Scalloped duvet cover' },
        { src: 'https://cdn.shopify.com/s/files/1/0881/5227/7265/files/ackngshtorg_orange_flat_sheet_2.webp?width=1400',                alt: 'Orange Scalloped detail' }
      ]
    }
  ],

  products: [
    {
      key: 'duvet-cover',
      name: 'Duvet Cover',
      eyebrow: 'The headline piece',
      lede: 'Pure cotton with a hand-finished scalloped edge in a matching thread. Buttoned closure at the foot. Sized to be generous, never tight on the duvet.',
      sizesOrder: ['single', 'double', 'king', 'super-king'],
      sizes: {
        'single':     { label: 'Single',     dimensions: '135 × 200 cm' },
        'double':     { label: 'Double',     dimensions: '200 × 200 cm' },
        'king':       { label: 'King',       dimensions: '230 × 220 cm' },
        'super-king': { label: 'Super King', dimensions: '260 × 220 cm' }
      },
      defaultQty: 1,
      /* Pricing & SKUs per colour and size. Prices in GBP. */
      matrix: {
        'navy':   { 'single': { price: 105, sku: 'ACSCASNGLNVY', inStock: true },
                    'double': { price: 120, sku: 'ACSCASDBLNVY', inStock: true },
                    'king':   { price: 139, sku: 'ACSCAKNGNVY',  inStock: true },
                    'super-king': { price: 154, sku: 'ACSCASUPNVY', inStock: true } },
        'white':  { 'single': { price: 105, sku: 'ACSCASNGLWTE', inStock: true },
                    'double': { price: 120, sku: 'ACSCADBLWHT',  inStock: true },
                    'king':   { price: 139, sku: 'ACSCAKNGWHT',  inStock: true },
                    'super-king': { price: 154, sku: 'ACSCASUPWHT', inStock: true } },
        'pink':   { 'single': { price: 105, sku: 'ACSCASNGLSGPNK', inStock: true },
                    'double': { price: 120, sku: 'ACSCASBLSGPNK',  inStock: true },
                    'king':   { price: 139, sku: 'ACSCAKNGSGPNK',  inStock: true },
                    'super-king': { price: 154, sku: 'ACSCASUPSGPNK', inStock: true } },
        'green':  { 'single': { price: 105, sku: 'ACSCASNGLGRN',  inStock: true },
                    'double': { price: 120, sku: 'ACSCADBLGRE',   inStock: true },
                    'king':   { price: 139, sku: 'ACSCAKNGGRE',   inStock: true },
                    'super-king': { price: 154, sku: 'ACSCASUPGRN', inStock: true } },
        'blue':   { 'single': { price: 105, sku: 'ACSCASNGLBLU',  inStock: true },
                    'double': { price: 120, sku: 'ACSCADBLBLU',   inStock: true },
                    'king':   { price: 139, sku: 'ACSCAKNGBLU',   inStock: true },
                    'super-king': { price: 154, sku: 'ACSCASUPBLU', inStock: true } },
        'red':    { 'single': { price: 105, sku: 'ACSCASNGLRED',  inStock: true },
                    'double': { price: 120, sku: 'ACSCADBLRED',   inStock: true },
                    'king':   { price: 139, sku: 'ACSCAKNGRED',   inStock: true },
                    'super-king': { price: 154, sku: 'ACSCASUPRED', inStock: true } },
        'coral':  { 'single': { price: 105, sku: 'ACSCASNGLPNK',  inStock: true },
                    'double': { price: 120, sku: 'ACSCADBLPNK',   inStock: true },
                    'king':   { price: 139, sku: 'ACSCAKNGPNK',   inStock: true },
                    'super-king': { price: 154, sku: 'ACSCASUPPNK', inStock: true } },
        'orange': { 'single': { price: 105, sku: 'ACSCASNGLORG',  inStock: true },
                    'double': { price: 120, sku: 'ACSCADBLORG',   inStock: true },
                    'king':   { price: 139, sku: 'ACSCAKNGORG',   inStock: true },
                    'super-king': { price: 154, sku: 'ACSCASUPORG', inStock: true } }
      }
    },
    {
      key: 'oxford-pillowcase',
      name: 'Oxford Pillowcase',
      eyebrow: 'Sold individually',
      lede: 'The everyday pillowcase. 50 × 75 cm with a flat scalloped border, sized to fit a standard UK pillow. Most beds need two.',
      sizesOrder: ['standard'],
      sizes: {
        'standard': { label: 'Standard', dimensions: '50 × 75 cm' }
      },
      defaultQty: 2,
      matrix: {
        'navy':   { 'standard': { price: 32.30, sku: 'ACSCAOXFNVY', inStock: true } },
        'white':  { 'standard': { price: 32.30, sku: 'ACSCAOXFWHT', inStock: true } },
        'pink':   { 'standard': { price: 32.30, sku: 'ACSCAOXFSGPNK', inStock: true } },
        'green':  { 'standard': { price: 32.30, sku: 'ACSCAOXFGRE', inStock: true } },
        'blue':   { 'standard': { price: 32.30, sku: 'ACSCAOXFBLU', inStock: true } },
        'red':    { 'standard': { price: 32.30, sku: 'ACSCAOXFRED', inStock: true } },
        'coral':  { 'standard': { price: 38.00, sku: 'ACSCAOXFPNK', inStock: false } },
        'orange': { 'standard': { price: 38.00, sku: 'ACSCAOXFORG', inStock: false } }
      }
    },
    {
      key: 'square-pillowcase',
      name: 'Square Pillowcase',
      eyebrow: 'Continental size',
      lede: 'A larger 65 × 65 cm square cushion-style pillow that sits behind the Oxfords. Adds depth and the kind of finish that hotels do well.',
      sizesOrder: ['square'],
      sizes: {
        'square': { label: 'Square', dimensions: '65 × 65 cm' }
      },
      defaultQty: 2,
      matrix: {
        'navy':   { 'square': { price: 35.70, sku: 'ACSCASQUNVY', inStock: true } },
        'white':  { 'square': { price: 35.70, sku: 'ACSCASQUWHT', inStock: true } },
        'pink':   { 'square': { price: 35.70, sku: 'ACSCASQUSGPNK', inStock: true } },
        'green':  { 'square': { price: 35.70, sku: 'ACSCASQUGRE', inStock: true } },
        'blue':   { 'square': { price: 35.70, sku: 'ACSCASQUBLU', inStock: true } },
        'red':    { 'square': { price: 35.70, sku: 'ACSCASQURED', inStock: true } },
        'coral':  { 'square': { price: 42.00, sku: 'ACSCASQUPNK', inStock: false } },
        'orange': { 'square': { price: 42.00, sku: 'ACSCASQUORG', inStock: false } }
      }
    },
    {
      key: 'super-king-pillowcase',
      name: 'Super King Pillowcase',
      eyebrow: 'The wide one',
      lede: 'A longer 50 × 90 cm pillowcase that runs the full width of a King or Super King bed. Sold individually. Two make a luxurious pair.',
      sizesOrder: ['super-king'],
      sizes: {
        'super-king': { label: 'Super King', dimensions: '50 × 90 cm' }
      },
      defaultQty: 2,
      matrix: {
        'navy':   { 'super-king': { price: 44.00, sku: 'ACSCASKNGNVY',   inStock: true } },
        'white':  { 'super-king': { price: 44.00, sku: 'ACSCASKNGPWHT',  inStock: true } },
        'pink':   { 'super-king': { price: 44.00, sku: 'ACSCASKNGPINK',  inStock: true } },
        'green':  { 'super-king': { price: 44.00, sku: 'ACSCASKNGGRN',   inStock: true } },
        'blue':   { 'super-king': { price: 44.00, sku: 'ACSCASKNGPBLU',  inStock: true } },
        'red':    { 'super-king': { price: 44.00, sku: 'ACSCASKNGPRED',  inStock: true } },
        'coral':  { 'super-king': { price: 44.00, sku: 'ACSCASKNGPPNK',  inStock: false } },
        'orange': { 'super-king': { price: 44.00, sku: 'ACSCASKNGORG',   inStock: false } }
      }
    }
  ]
};

/* Per-colour SEO + opening line.
   Each colour gets a slightly different page title, meta description and
   one-line opening tagline that sits above the main h1. The opening line
   is short (8–15 words) and Sophie-voiced. The aim is that each colour PDP
   feels like its own page, not a generic Scalloped landing. Search and
   social previews also pick up the right colour name and angle.

   Title format follows the SC pattern:
     "{ColourName} Scalloped Bed Linen · Sophie Conran"
   so listings show colour first. */
SC.scallopedColourSEO = {
  'navy': {
    title: 'Navy Scalloped Bed Linen · Sophie Conran',
    meta: 'Navy Scalloped bed linen by Sophie Conran. Pure cotton with a hand-finished scalloped edge. Duvet cover from £105, Oxford pillowcase £32.30. Sent from our UK warehouse, usually next working day.',
    opening: 'The grown-up dark blue. Almost black at night, deep and calm in daylight.'
  },
  'white': {
    title: 'White Scalloped Bed Linen · Sophie Conran',
    meta: 'White Scalloped bed linen by Sophie Conran. Pure cotton with a hand-stitched scalloped edge in matching thread. Duvet cover from £105. UK warehouse, usually next working day.',
    opening: 'The honest one. Pure white with a quiet, matching-thread scallop.'
  },
  'pink': {
    title: 'Pink Scalloped Bed Linen · Sophie Conran',
    meta: 'Pink Scalloped bed linen by Sophie Conran. Soft, warm pink with a hand-finished scalloped edge. Pure cotton. UK warehouse, usually next working day. Duvet cover from £105.',
    opening: 'A soft, warm Pink. Grown-up against dark wood, gentle against cream.'
  },
  'green': {
    title: 'Green Scalloped Bed Linen · Sophie Conran',
    meta: 'Green Scalloped bed linen by Sophie Conran. Soft sage green, pure cotton, hand-finished scalloped edge. Duvet cover from £105. UK warehouse, usually next working day.',
    opening: 'A soft sage Green. Does for a bedroom what plants do for a room.'
  },
  'blue': {
    title: 'Blue Scalloped Bed Linen · Sophie Conran',
    meta: 'Blue Scalloped bed linen by Sophie Conran. Washed-out sea-glass blue. Pure cotton, hand-finished scalloped edge. Duvet cover from £105. UK warehouse, usually next working day.',
    opening: 'Sea-glass Blue. Cool without being cold. Loved by rooms that catch the early light.'
  },
  'red': {
    title: 'Red Scalloped Bed Linen · Sophie Conran',
    meta: 'Red Scalloped bed linen by Sophie Conran. A warm, terracotta-leaning red. Pure cotton with a hand-finished scalloped edge. Duvet cover from £105. UK warehouse, usually next working day.',
    opening: 'A warm, terracotta-leaning Red. Dramatic against white, gentle against cream.'
  },
  'coral': {
    title: 'Coral Scalloped Bed Linen · Sophie Conran',
    meta: 'Coral Scalloped bed linen by Sophie Conran. Soft, sun-faded coral with a hand-finished scalloped edge. Pure cotton. Duvet cover from £105. UK warehouse, usually next working day.',
    opening: 'A sun-faded Coral. The colour of a Greek island at five in the afternoon.'
  },
  'orange': {
    title: 'Orange Scalloped Bed Linen · Sophie Conran',
    meta: 'Orange Scalloped bed linen by Sophie Conran. A clean, summer orange with a hand-finished scalloped edge. Pure cotton. Duvet cover from £105. UK warehouse, usually next working day.',
    opening: 'The brightest of the eight. A clean, summer Orange. A lift on a grey morning.'
  }
};

/* Complete-bed bundles.
   Three preset bundles for one-click adding. The bundle is a convenience —
   no discount is applied, the customer is just spared having to click each
   item individually. Each entry resolves to real SKUs via the products
   matrix using the chosen colour at click time.

   Composition rules (agreed with Sophie Conran for first launch):
     - Single bed: 1 duvet + 1 Oxford
     - Double bed: 1 duvet + 2 Oxfords
     - King bed:   1 duvet + 2 Oxfords + 2 Squares
   Super-King is not bundled — the Super-King pillowcase is a 'wide one'
   that customers tend to pick deliberately, not by default. */
SC.scallopedBundles = [
  {
    key: 'single',
    name: 'Single bed',
    label: 'For a single bed',
    blurb: '1 Single duvet cover + 1 Oxford pillowcase. Quick and complete.',
    items: [
      { productKey: 'duvet-cover',      size: 'single', sizeLabel: 'Single 135 × 200 cm', qty: 1 },
      { productKey: 'oxford-pillowcase', size: null,    sizeLabel: 'Oxford 50 × 75 cm',   qty: 1 }
    ]
  },
  {
    key: 'double',
    name: 'Double bed',
    label: 'For a double bed',
    blurb: '1 Double duvet cover + 2 Oxford pillowcases. The most-bought bundle.',
    items: [
      { productKey: 'duvet-cover',      size: 'double', sizeLabel: 'Double 200 × 200 cm', qty: 1 },
      { productKey: 'oxford-pillowcase', size: null,    sizeLabel: 'Oxford 50 × 75 cm',   qty: 2 }
    ]
  },
  {
    key: 'king',
    name: 'King bed',
    label: 'For a king bed',
    blurb: '1 King duvet cover + 2 Oxfords + 2 Squares. The full set.',
    items: [
      { productKey: 'duvet-cover',      size: 'king', sizeLabel: 'King 230 × 220 cm',   qty: 1 },
      { productKey: 'oxford-pillowcase', size: null,  sizeLabel: 'Oxford 50 × 75 cm',   qty: 2 },
      { productKey: 'square-pillowcase', size: null,  sizeLabel: 'Square 65 × 65 cm',   qty: 2 }
    ]
  }
];

/* ============================================================
   Option blurbs — short descriptions shown under the legs/piping
   options in the configurator, swapped as each option is selected
   by updateOptionBlurbs() in sc-components.js. Piping populated;
   add a `legs` map (keyed by leg-style value) when copy is ready.
   ============================================================ */
window.SC = window.SC || {};
window.SC.optionBlurbs = {
  piping: {
    'self-flat':      'A flat band of the same fabric sewn into the seams. The quietest finish, so the fabric and the shape lead.',
    'contrast-flat':  'A flat band in a second fabric, tracing the seams. A subtle way to bring in another colour.',
    'self-round':     'A rounded cord wrapped in the same fabric and set into the seams, for a soft, classic edge.',
    'contrast-round': 'A rounded cord in a second fabric. The most defined finish, drawing a clear outline around the piece.',
    'oxford':         'A wide flat border set in from the edge, like the cuff of a good shirt. Crisp and a touch more formal.',
    'soft-edge':      'No piping. The seams are simply turned for a rounded, relaxed edge and a softer, modern look.'
  }
};
